export default  {
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Cartier Philanthropy Annual Report 2020-2021",
  "shortTitle": "",
  "description": "",
  "width": 727,
  "height": 904,
  "currentLanguage": "EN",
  "languages": [
    {
    code: "EN",
    text: "English",
    href: "https://reports.cartierphilanthropy.org/AR2020-21/en"
    },
    {
    code: "FR",
    text: "French",
    href: "https://reports.cartierphilanthropy.org/AR2020-21/fr"
    }
  ],
  "basePath": "/AR2020-21/en",
  // "basePath": "",
  "companyLogo": "logo-white.png",
  "publishURL": "https://reports.cartierphilanthropy.org/AR2020-21/en/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": true,
    "downloadPath": '/AR2020-21/en/static/_content/Cartier-Philanthropy-Annual-Report-2020-2021.pdf',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": true,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": `
      <img class="halfScaleC 1-title" style="top:338px;left:993px;" src="/AR2020-21/en/static/_content/logo.png">        
      <img class="halfScale 1-sub" style="top:827px;left:1163px;" src="/AR2020-21/en/static/_content/1-sub-1.png">        
    `,
    "script": `
      function onPageEnter() {
        pg1Anim = new TimelineMax();
        pg1Anim.fromTo(cOf("1-title"), 0.6, {opacity:0, scale: 0}, {opacity:1, scale: 0.5, ease: Power2.easeOut}, 1)
        pg1Anim.fromTo(cOf("1-sub"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
      }

      function onPageLeave() {
        pg1Anim.stop();
      }
      `,
    "searchText": "ANNUAL REPORT 2020 - 2021"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": `
      <img class="halfScaleC 2-pie" style="top:-5px; left:236px;" src="/AR2020-21/en/static/_content/2-pie-2.png">        
      <img class="halfScaleC 2-pie" style="top:162px; left:-9px;" src="/AR2020-21/en/static/_content/2-pie-1.png">        
      <img class="halfScaleC 2-pie" style="top:229px; left:338px;" src="/AR2020-21/en/static/_content/2-pie-3.png">        
    `,
    "script": `
      function onPageEnter() {
        pg2Anim = new TimelineMax();
        pg2Anim.staggerFromTo(cOf("2-pie"), 1, {scale: 0}, {scale: 0.5, ease: Bounce.easeOut}, 0.3, 1)
      }

      function onPageLeave() {
        pg2Anim.stop();
      }
    `,
    "searchText": "BUDGET  Geographic distribution  ALLOCATION  By focus area 42%  54%  Africa  27%  Asia  11%  Latin America  4%  Europe  2%  Global  1%  North America  1%  Middle East  Basic services 31%  Basic services  Education  25.5%  24%  Sustainable livelihoods  23%  21%  Women’s social and economic development  Water & Sanitation  Nutrition  20.5%  Health  13% Emergencies response  NEW GRANT  FOLLOW-UP GRANT  1001fontaines  FOLLOW-UP GRANT  WSUP  Cambodia  FOLLOW-UP GRANT  Educate Girls  IECD  Madagascar  India  Madagascar  FOLLOW-UP GRANT  FOLLOW-UP GRANT  IECD  Azad Foundation  Madagascar  India  March  April  May  June  July  August  September  October  COVID-19 COVID-19  Médecins Sans Frontières  Italy, France, Belgium, Spain, Greece Chinese Red Cross  Wuhan city Homeland of Humanity Fund  United Arab Emirates  Integrate Health COVID-19  Visiting Nurse Service of New York, Harlem Children’s Zone, DonorsChoose  North America Techo  Brazil, Colombia, Mexico  Togo Living Goods  Kenya PIVOT  Madagascar Saha Global  Ghana  COVID-19  Baan Dek Foundation  2020  Thailand CBM  Indonesia  SOIL  Philippine Disaster Resilience Foundation  Haiti  Philippines  Medair  Lebanon BRAC  Bangladesh"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": `
      <h1 id="3-no1" class="abs brillcutreg 3-no" style="left: 49px; top: 95px; font-size: 4.4em; font-weight:400; margin:0; color:#808285; padding:0; margin:0;"  data-number='{"to": 75.5, "decimals": 1}'></h1>
      <h1 id="3-no2" class="abs brillcutreg 3-no" style="left:269px;top:178px; font-size: 4.4em; font-weight:400; margin:0; color:#808285; padding:0; margin:0;"  data-number='{"to": 50}'></h1>
      <h1 id="3-no3" class="abs brillcutreg 3-no" style="left:198px;top:283px; font-size: 4.4em; font-weight:400; margin:0; color:#808285; padding:0; margin:0;"  data-number='{"to": 34}'></h1>
    `,
    "script": `
      function onPageEnter() {
        pg3Anim = new TimelineMax();
        pg3Anim.fromTo(cOf("3-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("3-no")[0]);}}, 1)
        .fromTo(cOf("3-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("3-no")[1]);}}, "+=0.2")
        .fromTo(cOf("3-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("3-no")[2]);}}, "+=0.2")
      }

      function onPageLeave() {
        pg3Anim.stop();
        resetNumbers("3-no");
        removeContentLinks();
      }
    `,
    "searchText": "75.5  million Swiss francs invested to date  50 34  partners  for a stronger future  countries  NEW GRANTS FOLLOW-UP GRANT  FOLLOW-UP GRANT  Proximity Designs  Women for Women International  Myanmar  Kosovo , Bonsia & Herzegovina  FOLLOW-UP GRANT  Semilla Nueva  NEW GRANT  PIVOT  Guatemala Madagascar FOLLOW-UP GRANT  Buildher  NEW GRANT  CorStone  Kenya Rwanda NEW GRANT  World Bicycle Relief  Zambia  November  December  February  March  May  2021 COVID-19 COVID-19  COVID-19 Action Fund for Africa  Médecins Sans Frontières, Educate Girls  India  EMERGENCY RESPONSE"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": `
    <img class="halfScale 4-text" style="top:513px; left:142px;" src="/AR2020-21/en/static/_content/4-text-1.png">
    <img class="halfScale 4-text" style="top:267px; left:463px;" src="/AR2020-21/en/static/_content/4-text-2.png">
    `,
    "script": `
      function onPageEnter() {
        pg4Anim = new TimelineMax();
        pg4Anim.staggerFromTo(cOf("4-text"), 0.6, {opacity:0,x:-60}, {opacity:1,x:0, ease: Power2.easeOut}, 0.3, 1)
      }

      function onPageLeave() {
      pg4Anim.stop();
      }
    `,
    "searchText": "THE P RO G R AMMES  WE S UP P OR T MOROCCO  I  MALI  I  SENEGAL  I  GAMBIA  I  GUINEA-BISSAU  I  BURKINA FASO  I  GHANA  I  Area: Sustainable livelihoods Partner: Education for Employment  Area: Access to basic services (health) Partner: Muso  Areas: Women’s social and economic development, Sustainable livelihoods Partners: MSI Reproductive Choices, MyAgro, Tostan  Area: Women’s social and economic development Partner: Tostan  GUATEMALA  I  Area: Access to basic services (nutrition) Partner: Semilla Nueva  HAITI  I  Area: Access to basic services (sanitation) Partner: SOIL  PERU  I  Area: Sustainable livelihoods Partners: Root Capital, Terre des Hommes Suisse  Area: Women’s social and economic development Partner: Tostan  Area: Access to basic services (education, nutrition) Partner: WFP  Area: Access to basic services (water) Partner: Saha Global  TOGO  I  Area: Access to basic services (health) Partner: Integrate Health  RWANDA  I  Areas: Access to basic services (health, education), Women’s social and economic development, Sustainable livelihoods Partners: CorStone, ICRW, One Acre Fund, Women for Women International"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": `
    <img class="halfScale 5-text" style="top:72px; left:34px;" src="/AR2020-21/en/static/_content/5-text-1.png">
    <img class="halfScale 5-text" style="top:549px; left:-41px;" src="/AR2020-21/en/static/_content/5-text-3.png">
    <img class="halfScale 5-text" style="top:330px; left:257px;" src="/AR2020-21/en/static/_content/5-text-2.png">
    `,
    "script": `
      function onPageEnter() {
        pg5Anim = new TimelineMax();
        pg5Anim.staggerFromTo(cOf("5-text"), 0.6, {opacity:0,x:-60}, {opacity:1,x:0, ease: Power2.easeOut}, 0.3, 1)

      }

      function onPageLeave() {
      pg5Anim.stop();
      }
    `,
    "searchText": "I BOSNIA & HERZEGOVINA  I  I  LEBANON  Area: Access to basic services (education), Emergency response Partners: IECD, Medair  Area: Women’s social and economic development Partner: Women for Women International  I  KOSOVO  JORDAN  Area: Access to basic services (education, nutrition) Partner: WFP  Area: Women’s social and economic development Partner: Women for Women International  I  INDIA  Areas: Access to basic services (education), Women’s social and economic development, Sustainable livelihoods Partners: Azad Foundation, Educate Girls, Kheyti I  BANGLADESH  Areas: Access to basic services (education), Women’s social and economic development, Emergency response Partners: Asian University for Women, BRAC, Room to Read, VisionSpring I I  Area: Access to basic services (education) Partner: The Luminos Fund  I  services (water and sanitation), Sustainable livelihoods  Partners: IFRC, Proximity Designs  UGANDA  Areas: Women’s social and economic development, Sustainable livelihoods Partners: BRAC, mothers2mothers, Village Enterprise I  I  ZAMBIA  Areas: Access to basic services (education, health), Women’s social and economic development, Sustainable livelihoods Partners: Healthy Learners, StrongMinds, World Bicycle Relief  I  TANZANIA  Area: Women’s social and economic development Partners: Hand in Hand International, ICRW I  MOZAMBIQUE  Area: Access to basic services (education, nutrition) Partner: WFP  KENYA  Areas: Access to basic services (health), Women’s social and economic development Partners: The BOMA Project, Buildher, Living Goods I  MYANMAR  Areas: Access to basic  ETHIOPIA  MADAGASCAR  Areas: Access to basic services (education, health, water and sanitation), Sustainable livelihoods Partners: Blue Ventures, IECD, PIVOT, WSUP  I  CAMBODIA  Area: Access to basic services (water and sanitation) Partners: 1001fontaines, IFRC"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": `
      <img class="halfScale 6-text" style="top:428px; left:180px;" src="/AR2020-21/en/static/_content/6-text-1.png">
    `,
    "script": `
      function onPageEnter() {
        pg6Anim = new TimelineMax();
        pg6Anim.fromTo(cOf("6-text"), 0.6, {opacity:0, x: -30}, {opacity:1, x: 0, ease: Power2.easeOut}, 1)
      }

      function onPageLeave() {
        pg6Anim.stop();
      }
      `,
    "searchText": "OUR AMBITION IS TO HELP FREE EVERYONE’S POTENTIAL"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": `
    <div class="contentLinkNone" style="top:185px;left:319px;width:263px;height:64px;" onclick="Publish.goToPage(8)"></div>
    <div class="contentLinkNone" style="top:278px;left:319px;width:263px;height:64px;" onclick="Publish.goToPage(9)"></div>
    <div class="contentLinkNone" style="top:369px;left:319px;width:263px;height:84px;" onclick="Publish.goToPage(10)"></div>
    <div class="contentLinkNone" style="top:482px;left:319px;width:263px;height:64px;" onclick="Publish.goToPage(15)"></div>
    <div class="contentLinkNone" style="top:576px;left:319px;width:350px;height:64px;" onclick="Publish.goToPage(27)"></div>
    <div class="contentLinkNone" style="top:668px;left:319px;width:350px;height:64px;" onclick="Publish.goToPage(35)"></div>
    <div class="contentLinkNone" style="top:759px;left:319px;width:350px;height:64px;" onclick="Publish.goToPage(43)"></div>
  `,
  "script": `
    function onPageEnter() {
      setTimeout(function(){
        addContentLinks();
      }, 1000);
    }

    function onPageLeave() {
      removeContentLinks();
    }
  `,
    "searchText": "SUMMARY  8 Message from the President  9  Strategic Advisor’s Message  10  Combating COVID-19 worldwide A year in review  15 Access to basic services  27  Women’s social and economic development  35  Sustainable livelihoods and ecosystems  43  Emergency response and preparedness"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.png",
    "zoom": null,
    "content": `
      <div class="contentLinkNone abs" style="top:79px;left:148px;width:423px;height:604px;" onclick="Publish.openArticle(0)"></div>
    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "searchText": "ME SSAGE F ROM THE P RES IDENT It really is exceptionally difficult to put the last twelve months into words. The COVID-19 pandemic was unprecedented, exposing sweeping vulnerabilities in countries that are normally well-equipped to cope with emergencies while exacerbating already severe inequalities in the world’s poorest regions. Global by nature, it called for an extraordinary response, where communities – local, national and international – suddenly emerged from the shadows of abstraction to become the visible fabric that binds us together as a whole. As a result, I believe we are all more aware of the value of social connections today, of neighbourliness, of a sense of belonging and of mutual trust. We know from experience that this togetherness makes us stronger in the face of adversity. Communities - diverse, informed, supportive and resilient - are our best defence. Cartier and Cartier Philanthropy have contributed actively to the relief efforts since the very beginning of the crisis, providing access to healthcare, education, food, water and sanitation for those most in need, wherever they live - from Italy to the Philippines, Brazil, Madagascar and, most recently, India. Care, compassion, thoughtfulness and collaboration have guided us through the storm, supporting 18 non-profit organisations in 20 countries across every region of the world. Let these values remain our compass as we recover and find ways to build a more equitable, just and inclusive post-COVID world. The stakes are too high to simply go back to the old normal. Cyrille Vigneron President of the Board, Cartier Philanthropy CEO of Cartier  8"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.png",
    "zoom": null,
    "content": `
    <div class="contentLinkNone abs" style="top:79px;left:138px;width:423px;height:604px;" onclick="Publish.openArticle(1)"></div>
    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "searchText": "STRATE GI C A DVIS OR’ S MES S AGE After months on a non-stop emotional roller-coaster, marked by losses, struggles and grief, but also the inspiration that comes from extraordinary displays of courage and solidarity, I’d like to dedicate these words to honouring our incredible partner organisations, who never failed to step up and fight for the people they serve, among the most vulnerable on earth. Since the very beginning of the COVID-19 pandemic, when the one sure thing was that “the only way out was through”, they reacted, adapted, strategized, repurposed and restructured with decisive resolution, demonstrating flexibility, creativity and pragmatism. Identifying potential risks and vulnerabilities, they ensured that critical front-line needs were addressed and no one was left behind, adopting innovative approaches and safety measures to continue delivering on their missions. Because that was all that counted. Make no mistake, they were blind to the crisis like every one of us. But their tenacity in keeping focused throughout the chaos while maintaining a flexible outlook testifies strongly to their extraordinary passion, bravery, determination and resourcefulness. With the crisis not yet over, calling us to face challenges old and new, I believe these examples of unwavering commitment and boundless endurance will be among the most precious legacies of this difficult period. You will recognise them in the following pages, which I invite you to explore, reading about the life-changing impact they have had and will continue to have on so many. Pascale de la Frégonnière Strategic Advisor, Cartier Philanthropy  9"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": `
    <img class="halfScaleC 10-img" src="/AR2020-21/en/static/_content/10-img-1.png" style="top:35px;left:-88px;">
    <img class="halfScaleC 10-img" src="/AR2020-21/en/static/_content/10-img-2.png" style="top:34px;left:291px;">
    <img class="halfScaleC 10-img" src="/AR2020-21/en/static/_content/10-img-3.png" style="top:421px;left:-131px;">
    <img class="halfScaleC 10-img" src="/AR2020-21/en/static/_content/10-img-4.png" style="top:634px;left:-131px;">
    <img class="halfScaleC 10-img" src="/AR2020-21/en/static/_content/10-img-5.png" style="top:354px;left:150px;">
    <img class="halfScaleC 10-img" src="/AR2020-21/en/static/_content/10-img-6.png" style="top:422px;left:345px;">
    <img class="halfScaleC 10-img" src="/AR2020-21/en/static/_content/10-img-7.png" style="top:600px;left:345px;">
    `,
    "script": `
      function onPageEnter() {
        pg10Anim = new TimelineMax();
        pg10Anim.staggerFromTo(cOf("10-img"), 0.6, {opacity:0, scale: 0}, {opacity:1, scale: 0.5, ease: Power2.easeOut}, 0.2, 0.4)
      }

      function onPageLeave() {
        pg10Anim.stop();
      }
      `,
    "searchText": "COMBATING COVID-19 WORLDWIDE – A YEAR IN REVIEW  10"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": `
    <img class="halfScaleC 11-img" src="/AR2020-21/en/static/_content/11-img-1.png" style="top:-261px;left:-186px;">
    <img class="halfScaleC 11-img" src="/AR2020-21/en/static/_content/11-img-2.png" style="top:318px;left:-186px;">
    <img class="halfScaleC 11-img" src="/AR2020-21/en/static/_content/11-img-3.png" style="top:34px;left:186px;">
    <img class="halfScaleC 11-img" src="/AR2020-21/en/static/_content/11-img-4.png" style="top:353px;left:230px;">
    `,
    "script": `
      function onPageEnter() {
        pg11Anim = new TimelineMax();
        pg11Anim.staggerFromTo(cOf("11-img"), 0.6, {opacity:0, scale: 0}, {opacity:1, scale: 0.5, ease: Power2.easeOut}, 0.2, 0.5)
      }

      function onPageLeave() {
        pg11Anim.stop();
      }
      `,
    "searchText": "11"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": `
    <img class="halfScale 12-text" style="top:475px; left:116px;" src="/AR2020-21/en/static/_content/12-text-1.png">
    <img class="halfScale 12-text" style="top:575px; left:246px;" src="/AR2020-21/en/static/_content/12-text-2.png">
    <div class="contentLinkNone abs" style="top:89px;left:78px;width:453px;height:304px;" onclick="Publish.openArticle(2)"></div>
    <div class="contentLinkNone abs" style="top:469px;left:108px;width:283px;height:154px;" onclick="Publish.openArticle(2)"></div>
    <div class="contentLinkNone abs" style="top:665px;left:237px;width:263px;height:127px;" onclick="Publish.openArticle(2)"></div>
    `,
    "script": `
      function onPageEnter() {
        var pages = cOf("leftPage")
        for (var i = 0; i < pages.length; i++) {
          pages[i].style.zIndex = 0;
        }
        pg12Anim = new TimelineMax();
        pg12Anim.staggerFromTo(cOf("12-text"), 0.6, {opacity:0,x:-60}, {opacity:1,x:0, ease: Power2.easeOut}, 0.3, 1)
      }

      function onPageLeave() {
        var pages = cOf("leftPage")
        for (var i = 0; i < pages.length; i++) {
          pages[i].style.zIndex = -1;
        }
      pg12Anim.stop();
      }
    `,
    "searchText": "COMBATING COVID-19 WORLDWIDE A YEAR IN REVIEW We’ve always been committed to addressing the most pressing challenges faced by the world’s least developed regions, where difficulty meeting basic needs can be severe year-round. Confronted with the worst health and humanitarian crisis the world has ever faced, we felt compelled to contribute to the global relief effort, providing assistance where and when needed (even in wealthy countries) as the emergency unfolded and its consequences became better known. Over the past year, we have supported our partners’ relief operations in 20 countries across the globe, providing access to healthcare, education, food, water and sanitation.  NORTH AMERICA  The Visiting Nurse Service of New York has sent 11,000 clinicians and home health aides into patients’ homes, alleviating the pressure on hospitals. Harlem Children’s Zone has provided essential social services for over 10,000 people hit hard by the crisis. DonorsChoose has provided teachers and over 35,600 students with home learning support.  LATIN AMERICA & THE CARIBBEAN  Techo has provided the most vulnerable families with food and other necessities, distributing over 4,200 emergency kits in Mexico, Brazil, and Colombia. In Haiti, SOIL has provided critical access to safe sanitation and handwashing stations for hundreds of users per day.  * Donation made in 2019-2020 fiscal year - ** Donation made directly by Cartier - *** Donation made in 2021-2022 fiscal year  12"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": `
    <img class="halfScale 13-text" style="top:86px; left:70px;" src="/AR2020-21/en/static/_content/13-text-1.png">
    <img class="halfScale 13-text" style="top:200px; left:207px;" src="/AR2020-21/en/static/_content/13-text-2.png">
    <img class="halfScale 13-text" style="top:122px; left:397px;" src="/AR2020-21/en/static/_content/13-text-3.png">
    <img class="halfScale 13-text" style="top:615px; left:71px;" src="/AR2020-21/en/static/_content/13-text-4.png">
    <img class="halfScale 13-text" style="top:610px; left:209px;" src="/AR2020-21/en/static/_content/13-text-5.png">
    <img class="halfScale 13-text" style="top:563px; left:322px;" src="/AR2020-21/en/static/_content/13-text-6.png">
    <div class="contentLinkNone abs" style="top:77px;left:62px;width:213px;height:106px;" onclick="Publish.openArticle(2)"></div>
    <div class="contentLinkNone abs" style="top:189px;left:198px;width:213px;height:116px;" onclick="Publish.openArticle(2)"></div>
    <div class="contentLinkNone abs" style="top:112px;left:511px;width:175px;height:357px;" onclick="Publish.openArticle(2)"></div>
    <div class="contentLinkNone abs" style="top: 555px; left: 510px; width: 167px; height: 224px;" onclick="Publish.openArticle(2)"></div>
    <div class="contentLinkNone abs" style="top:699px;left:58px;width:433px;height:144px;" onclick="Publish.openArticle(2)"></div>
    `,
    "script": `
      function onPageEnter() {
        pg13Anim = new TimelineMax();
        pg13Anim.staggerFromTo(cOf("13-text"), 0.6, {opacity:0,x:-60}, {opacity:1,x:0, ease: Power2.easeOut}, 0.3, 1)
      }

      function onPageLeave() {
      pg13Anim.stop();
      }
    `,
    "searchText": "EUROPE  Médecins Sans Frontières has delivered medical care to people on the move, the homeless and elderly people living in long-term care facilities in Italy, France, Belgium, Spain and Greece.*  ASIA  CHINA AND THE MIDDLE EAST  Cartier contributed early donations to support the Red Cross in Wuhan, China, and The Fund of the United Arab Emirates Homeland of Humanity.**  In Thailand, Baan Dek Foundation has provided hygiene products, food rations and housing support for families living in Bangkok and Chiang Mai construction camps. In Indonesia, CBM has ensured information on COVID-19 is accessible for people with disabilities, while also providing medicines and cash to 800 households. In the Philippines, the Philippine Disaster Resilience Foundation has provided personal protective equipment and accommodation for 6,500 healthcare workers in 68 hospitals and community centres in Metro Manila, Cebu City and Lanao Del Sur.  ASIA  AFRICA  Integrate Health in Togo, PIVOT in Madagascar, Living Goods in Kenya and Saha Global in Ghana have worked to limit the spread of the virus, while ensuring essential health services and water access are maintained.  The COVID-19 Action Fund for Africa (CAF-Africa), a collaborative initiative of more than 30 member organisations, is supplying personal protective equipment for 1 million community health workers across the continent.  In India, Médecins Sans Frontières has provided medical assistance to moderate and critical COVID-19 patients while ensuring continuity of care for people suffering from tuberculosis. Educate Girls has provided assistance to 115,000 rural vulnerable households by purchasing and distributing grocery and hygiene kits.***  13"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": ``,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "searchText": ""
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": `
      <img class="halfScale 15-title" style="top:249px; left:167px;" src="/AR2020-21/en/static/_content/15-title-1.png">
      <img class="halfScale 15-sub" style="top:305px; left:361px;" src="/AR2020-21/en/static/_content/15-sub-1.png">
      <div class="contentLinkNone abs" style="top:239px;left:157px;width:473px;height:284px;" onclick="Publish.openArticle(3)"></div>

    `,
    "script": `
      function onPageEnter() {
        pg15Anim = new TimelineMax();
        pg15Anim.fromTo(cOf("15-title"), 0.6, {opacity:0,x:-60}, {opacity:1,x:0, ease: Power2.easeOut}, 1)
        pg15Anim.fromTo(cOf("15-sub"), 0.6, {opacity:0,x:-60}, {opacity:1,x:0, ease: Power2.easeOut}, 1.3)
      }

      function onPageLeave() {
      pg15Anim.stop();
      }
    `,
    "searchText": "ACCESS TO BASIC SERVICES The coronavirus crisis has revealed that we all stand to gain from a foundation of universal basic services that not only help ensure society flourishes but also protect us, now and in the future. Quality healthcare, clean drinking water, functioning schools and nutritious food are not desirables, but necessities. If anyone is unable to access them, it’s not just bad news for them. We all lose."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": `
      <h1 id="16-no1" class="abs brillcutmed 16-no" style="left: 553px; top: 575px; font-size: 2.2em; font-weight:400; margin:0; color:#218ccd; padding:0; margin:0;"  data-number='{"to": 82, "append": "%"}'></h1>
      <div class="contentLinkNone abs" style="top:592px;left:79px;width:363px;height:254px;" onclick="Publish.openArticle(4)"></div>
    `,
    "script": `
      function onPageEnter() {
        pg16Anim = new TimelineMax();
        pg16Anim.fromTo(cOf("16-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("16-no")[0]);}}, 1)
      }

      function onPageLeave() {
        pg16Anim.stop();
        resetNumbers("16-no");
        removeContentLinks();
      }
    `,
    "searchText": "NEW PROGRAMMES  Partner: 1001fontaines Country: Cambodia Duration: 2020-2022  Small enterprises for clean water In Cambodia, one in three people living in rural communities uses water from unsafe sources. 1001fontaines has been pioneering a social business model that harnesses local entrepreneurship and low-cost technology. Their approach consists in setting up small solar water purification plants, called water kiosks, and training local entrepreneurs to produce safe drinking water, sell it to villagers at an affordable price and distribute it to schools free of charge. This solution has proven its cost-effectiveness, sustainability and strong positive impact on people’s health. We’re supporting 1001fontaines to set up 80 new water kiosks over the next two years and thus grow its operating network to 300 water kiosks serving 900,000 people by 2022. 16 - A CCE S S TO BA SIC SER VICES  82%  of the water kiosks set up since 2005 are still up and running"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": `
    <div class="contentLinkNone abs" style="top: 592px; left: 59px; width: 363px; height: 254px;" onclick="Publish.openArticle(4)"></div>
    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "searchText": "Resilience training changes lives Young people facing challenges benefit significantly from assets such as self-confidence, self-efficacy, optimism, persistence, assertive communication and problem-solving skills, which greatly help overcome obstacles. They are not innate talents, however, but skills that can be taught. Youth First Rwanda is a programme designed to improve the mental and physical well-being and education-related outcomes of lower secondary school students. It is currently being implemented in a small number of pilot schools in Kigali.  We’re supporting CorStone to train 350 teachers to facilitate resilience sessions and progressively build tangible resilience skills in 7,500 young students.  Partner: CorStone Country: Rwanda Duration: 2021-2022  Resilience sessions increase youth confidence to complete their education, delay marriage and childbirth, and achieve career and other life goals. AC C ES S TO BAS IC S ERVIC ES - 17"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": `
      <h1 id="18-no1" class="abs brillcutreg 18-no" style="left: 86px; top: 793px; font-size: 1.6em; font-weight:400; margin:0; color:#218ccd; padding:0; margin:0;"  data-number='{"to": 80, "append": "%"}'></h1>
      <div class="contentLinkNone abs" style="    top: 152px; left: 319px; width: 343px; height: 357px;" onclick="Publish.openArticle(4)"></div>
      <div class="contentLinkNone abs" style="top:562px;left:79px;width:363px;height:224px;" onclick="Publish.openArticle(4)"></div>

    `,
    "script": `
      function onPageEnter() {
        pg18Anim = new TimelineMax();
        pg18Anim.fromTo(cOf("18-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("18-no")[0]);}}, 1)
      }

      function onPageLeave() {
        pg18Anim.stop();
        resetNumbers("18-no");
        removeContentLinks();
      }
    `,
    "searchText": "NEW PROGRAMMES Last mile primary care in Madagascar PIVOT has been working alongside the Madagascar Ministry of Public Health since 2014 to transform the public health system in the rural district of Ifanadiana into an evidence-based model of universal health coverage that can be sustained, replicated, and scaled nationally. PIVOT delivers high-quality primary care in health centres across the district, ensuring all facilities are staffed and equipped. With over 70% of the population living more than a 5-kilometre walk from the nearest health facility, PIVOT supports community-level health services through a network of professionalised community health workers who proactively bring care to the patient’s door. The organisation also provides comprehensive support for the district’s public hospital.  Partner: PIVOT Country: Madagascar Duration: 2021-2023  22 health facilities will be equipped, and 207 community health workers trained  We’re supporting PIVOT’s expansion plan to achieve full primary healthcare coverage in the Ifanadiana district.  Building a life of learning Education levels in Madagascar are among the lowest in the world, with 26% of children under 15 being illiterate. IECD and the Malagasy non-profit organisation PROMES are working to reduce the school drop-out rates of youths in the rural communities of Fianarantsoa region. Their academic support centres offer individual guidance to students, enabling them to enhance their learning and build their personal development. After a successful three-year first grant, we’re now co-funding five centres in the Fianarantsoa region which will provide guidance for a total of 430 pupils over three years.  80%  of students passed their secondary school exams (BECP) compared with a national average of 53% 18 - A CCE S S TO BA SIC SER VICES  Partner: IECD Country: Madagascar Duration: 2017-19 > 2020-23"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": `
    <img class="halfScale 19-text pointer" style="top:542px; left:71px;"  onclick="Publish.openArticle(5)" src="/AR2020-21/en/static/_content/19-text-1.png">
    <img class="halfScale 19-text pointer" style="top:759px; left:297px;"  onclick="Publish.openArticle(5)" src="/AR2020-21/en/static/_content/19-text-2.png">
    <div class="contentLinkNone abs" style="top:219px;left:61px;width:283px;height:308px;" onclick="Publish.openArticle(5)"></div>
    `,
    "script": `
      function onPageEnter() {
        pg19Anim = new TimelineMax();
        pg19Anim.staggerFromTo(cOf("19-text"), 0.6, {opacity:0,y:-60}, {opacity:1,y:0, ease: Power2.easeOut}, 0.3, 1)
      }

      function onPageLeave() {
      pg19Anim.stop();
      }
    `,
    "searchText": "RESULTS A ND FOLLOW-UP Partner: Educate Girls Country: India Duration: 2014-17 > 2017-20 > 2020-24  Supporting Indian girls into classrooms Educate Girls’ comprehensive model to help reduce the education gender gap in India has snowballed over the past 14 years, proving that it can increase girls’ enrolment and attendance in schools, promote girl-friendly education infrastructures and improve learning outcomes for children. Targeting villages with higher concentrations of out-of-school girls – identified using predictive machine learning techniques – Educate Girls builds awareness of the opportunities that come from girls’ education and the roles that parents and communities can and should play in the improvement of school infrastructures and governance. We’ve been supporting Educate Girls in Rajasthan state since 2014 while it fine-tuned and replicated its model to ensure no girl is left behind. A first grant successfully enrolled over 37,500 girls in Rajsamand district, achieving a retention rate of 93.5%. From 2017 to 2020, our support enabled the enrollment of a further in the same district, achieving an outstanding 97% retention rate.  16,800 girls  Over 8,000 girls have been empowered with essential life skills to boost their confidence and build their communication, leadership, public-speaking, health, sanitation and problem-solving skills. Nearly 1,850 School Management Committees of parents, teachers and village leaders responsible for school governance and administration have been formed, directly involving over 15,100 members.  2020-2024  We’re now providing core funding to enable Educate Girls to scale up its operations and enroll up to 1.5 million out-of-school girls across 35,000 villages by 2024 in India’s four most populous states: Rajasthan, Madhya Pradesh, Uttar Pradesh and Bihar. AC C ES S TO BAS IC S ERVIC ES - 19"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": `
    <img class="halfScale 20-text pointer" style="top:571px; left:89px;" onclick="Publish.openArticle(5)" src="/AR2020-21/en/static/_content/20-text-1.png">
    <img class="halfScale 20-text pointer" style="top:759px; left:320px;" onclick="Publish.openArticle(5)" src="/AR2020-21/en/static/_content/20-text-2.png">
    <div class="contentLinkNone abs" style="top:199px;left:323px;width:340px;height:358px;" onclick="Publish.openArticle(5)"></div>
    `,
    "script": `
      function onPageEnter() {
        pg20Anim = new TimelineMax();
        pg20Anim.staggerFromTo(cOf("20-text"), 0.6, {opacity:0,y:-60}, {opacity:1,y:0, ease: Power2.easeOut}, 0.3, 1)
      }
    
      function onPageLeave() {
      pg20Anim.stop();
      }
    `,
    "searchText": "RESULTS A ND FOLLOW-UP Bringing water to the urban poor Partner: Water & sanitation for the Urban Poor (WSUP) Country: Madagascar Duration: 2017-20 > 2020-23  The challenges of access to safe sanitation are growing as the world continues to urbanise. This is particularly true in Madagascar, where the number of people living in urban areas is rising at twice the rate as the rest of the country, putting existing sanitation services under increasing pressure. WSUP works with the national water company, local government bodies and communities in Antananarivo to design and build or rehabilitate dedicated services in a manner that ensures their financial viability. WSUP’s approach goes beyond “taps and toilets”, aiming to achieve profound social and functional transformations in water and sanitation systems and policies. The results achieved have been remarkable: The technical assistance and training provided to the national water utility company enabled it to reduce leakage and metering inaccuracies while substantially increasing water supply capacity, providing over 52,200 people with clean drinking water.  18 water kiosks and 3 laundry blocks connected to the city water supply have been established, serving nearly 7,000 people. 13 water and sanitation facilities have been built or rehabilitated in 31 schools, over 4,700 school children and 160 teachers.  serving  6,665 people gained improved access to household sanitation.  2020-2023  20 - A CCE S S TO B A SIC SER VICES  For the next three years, we’ll be supporting WSUP’s efforts to develop its activities in Antananarivo, Mahajanga, Toliara and their peri-urban areas following a city-wide inclusive sanitation model to achieve universal sanitation coverage for a further 100,000 people."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": `
    <img class="halfScale 21-text pointer" style="top:555px; left:71px;" onclick="Publish.openArticle(5)" src="/AR2020-21/en/static/_content/21-text-1.png">
    <img class="halfScale 21-text pointer" style="top:743px; left:71px;" onclick="Publish.openArticle(5)" src="/AR2020-21/en/static/_content/21-text-2.png">
    <h1 id="21-no1" class="abs fancycutbold 21-no" style="left: 526px; top: 612px; font-size:2.2em; font-weight:400; margin:0; color:white; padding:0; margin:0;"  data-number='{"to": 300000, "comma": true}'></h1>
    <div class="contentLinkNone abs" style="top:419px;left:63px;width:580px;height:128px;" onclick="Publish.openArticle(5)"></div>
    `,
    "script": `
      function onPageEnter() {
        pg21Anim = new TimelineMax();
        pg21Anim.staggerFromTo(cOf("21-text"), 0.6, {opacity:0,y:-60}, {opacity:1,y:0, ease: Power2.easeOut}, 0.3, 1)
        .fromTo(cOf("21-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("21-no")[0]);}}, "-=0.3")
      }
    
      function onPageLeave() {
      pg21Anim.stop();
      }
    `,
    "searchText": "Partner: Semilla Nueva Country: Guatemala Duration: 2016-18 > 2019-21 > 2021-24  Fighting malnutrition with biofortified maize In Guatemala, corn tortillas are the ever-present staple of every meal despite being very poor in nutrients. This, combined with lack of dietary diversity, is responsible for chronic malnutrition in around half of Guatemalan children under five. Semilla Nueva produces and sells biofortified corn seeds conventionally bred to contain higher levels of quality proteins and zinc with the aim of improving the nutrition of millions of Guatemalans. We have been supporting Semilla Nueva to overcome the biggest bottlenecks in developing and expanding the use of biofortified crops in Guatemala since 2016. Between 2019 and 2021, they were able to extend the consumption of biofortified crops, selling nearly 5,200 sacks of seed and reaching over 15,300 farming families. These families produced over 25,000 metric tonnes of more nutritious maize.  Enough to feed nearly  300,000 people for a full year  2021-2024 The organisation aims to show that a government policy incentivising private seed companies to sell biofortified seeds can be one of the most cost-effective solutions for improving nutrition in the country. Semilla Nueva plans to scale the adoption of biofortified maize by targeting farmers, seed companies and government, while developing competitive new and improved varieties of biofortified seeds with the objective of changing over 800,000 people’s diets. AC C ES S TO BAS IC S ERVIC ES - 21"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": `
    <div class="contentLinkNone abs" style="top: 145px; left: 76px; width: 592px; height: 278px;" onclick="Publish.openArticle(6)"></div>
    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "searchText": "RESULTS Partner: IFRC Countries: Myanmar, Cambodia Duration: 2015-2020  Reaching where the water doesn’t  The main sources of water across much of rural Cambodia and Myanmar are still ponds, hand-dug wells and rainwater harvesting systems. Latrines are uncommon and knowledge of basic hygiene and sanitation practices is scant. Between 2015 and 2020, we supported IFRC and the Myanmar and Cambodian Red Cross to provide clean drinking water and affordable sanitation facilities in rural provinces at high risk of severe water stress.  In Cambodia  26,505 people and 11 schools gained access  to clean drinking water sources and nearly 20,300 people and 8 schools acquired access to improved sanitation facilities.  22 - A CCE S S TO B A SIC SER VICES  In Myanmar  13,126 people gained access to clean drinking water sources and nearly 11,400 people acquired access to improved sanitation facilities. All the communities became “Open Defecation Free”, which means every household now uses a functional latrine."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": `
      <h1 id="23-no1" class="abs fancycutbold 23-no" style="left: 334px; top: 453px; font-size: 2.2em; font-weight:400; margin:0; color:#218ccd; padding:0; margin:0;"  data-number='{"to": 1.51, "decimals": 2}'></h1>
      <div class="contentLinkNone abs" style="top:95px;left:56px;width:282px;height:748px;" onclick="Publish.openArticle(6)"></div>
    `,
    "script": `
      function onPageEnter() {
        pg23Anim = new TimelineMax();
        pg23Anim.fromTo(cOf("23-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("23-no")[0]);}}, 1)
      }

      function onPageLeave() {
        pg23Anim.stop();
        resetNumbers("23-no");
        removeContentLinks();
      }
    `,
    "searchText": "Delivering health door-to-door Community Health Workers (CHWs) provide the first line of medical care across most of rural Kenya. They go door-to-door to deliver health education, diagnoses and treatments, sell life-saving medicines and make referrals to formal health centres as needed, focusing on pregnant women, mothers and children under five. Living Goods supports networks of government CHWs to ensure they are digitally enabled, properly equipped, effectively supervised and fairly compensated. Over the past two years, we supported Living Goods’ efforts to replicate its model in western Kenya. This network In that time, the number of CHWs serves over grew by 115% to almost 2,700.  Partner: Living Goods Country: Kenya Duration: 2018-2021  1.51  million people  Zero crop losses for zero hunger In Mozambique, over 30% of crops Partner: WFP Country: Mozambique are regularly lost Duration: 2017-2020 in the weeks following harvest due to traditional household storage and poor crop handling. WFP reached out to 20,860 smallholder farmers – half of them women – and extension agents, training them to adopt improved practices and storage technologies to drastically reduce these postharvest losses. Nearly 50,000 hermetic bags were distributed, enabling the losses recorded to be reduced from 50% to 9%. AC C ES S TO BAS IC S ERVIC ES - 23"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": `
    <div class="contentLinkNone abs" style="top:95px;left:76px;width:592px;height:316px;" onclick="Publish.openArticle(7)"></div>
    <div class="contentLinkNone abs" style="top:555px;left:76px;width:592px;height:294px;" onclick="Publish.openArticle(7)"></div>
    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "searchText": "WORLD FOOD PROGRAMME  WORLD FOOD PROGRAMME  VISIONSPRING  Burkina Faso – 2014-2021  Jordan – 2018-2021  A women-led dairy supply chain is linking small-scale cattle farmers and local producers with 71 school canteens where 12,500 school children are being offered fresh yogurt as a mid-morning snack.  6,000 children are receiving school meals thanks to the Healthy Kitchens initiative which employs and empowers 30 Syrian refugee and vulnerable Jordanian women and men.  VisionSpring is pooling with BRAC to provide durable, attractive and affordable glasses to 600,000 low-income individuals.  Bangladesh – 2018-2021  ONGOING PROGRAMMES THE LUMINOS FUND Ethiopia – 2018-2021  INTEGRATE HEALTH  10,000 children living in the remote Afar and Oromia regions are being enrolled in a 10-month accelerated learning programme that will enable them to go back to state school.  Integrate Health has created a community-led low-cost model to make high-quality primary healthcare available to 240,000 Togolese by 2021.  24 - A CCE S S TO B A SIC SER VICES  Togo – 2019-2022  MUSO Mali – 2019-2022 Muso is working with community health workers and government clinics to improve the health of 450,000 patients directly, and of 18 million through government adoption of its model."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": `
    <div class="contentLinkNone abs" style="top:95px;left:76px;width:422px;height:753px;" onclick="Publish.openArticle(7)"></div>
    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "searchText": "HEALTHY LEARNERS Zambia – 2019-2022 School teachers are being trained to become front-line health workers and improve the health of 285,000 school children in Lusaka and Copperbelt provinces.  ROOM TO READ Bangladesh, Cambodia – 2019-2022 4,350 girls in Bangladesh and Cambodia are enrolled in an innovative Girls’ Education Programme to ensure they complete secondary school and gain the skills to negotiate key life decisions.  IECD Lebanon – 2019-2023 IECD’s Janah Centre in Beirut is enabling 535 Syrian and Lebanese children and youths to receive academic support, psychological assistance, extracurricular activities and a nutritious daily snack.  SAHA GLOBAL Ghana – 2019-2022 Nearly 1,000 women-led water treatment microbusinesses will be launched by the end of 2022 with the aim of providing clean drinking water to 440,000 people.  SOIL Haiti – 2019-2022 Safe and cost-effective urban sanitation services are being provided to 12,000 Haitians, combining container-based in-home toilets with regenerative waste treatment services. AC C ES S TO BAS IC S ERVIC ES - 25"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": ``,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "searchText": ""
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": `
      <img class="halfScale 27-title pointer" style="top:249px; left:140px;" onclick="Publish.openArticle(8)" src="/AR2020-21/en/static/_content/27-title-1.png">
      <img class="halfScale 27-sub pointer" style="top:340px; left:374px;" onclick="Publish.openArticle(8)" src="/AR2020-21/en/static/_content/27-sub-1.png">
    `,
    "script": `
      function onPageEnter() {
        pg27Anim = new TimelineMax();
        pg27Anim.fromTo(cOf("27-title"), 0.6, {opacity:0,x:-60}, {opacity:1,x:0, ease: Power2.easeOut}, 1)
        pg27Anim.fromTo(cOf("27-sub"), 0.6, {opacity:0,x:-60}, {opacity:1,x:0, ease: Power2.easeOut}, 1.3)
      }

      function onPageLeave() {
      pg27Anim.stop();
      }
    `,
    "searchText": "WOMEN’S SOCIAL AND ECONOMIC DEVELOPMENT Some concepts are like a pair of glasses that allow otherwise invisible things to be seen with sudden clarity. “Patriarchy” is one of them. It consists mainly in a societal structure of power that operates at the expense of women on multiple levels: the state, the law, the school, the home and the cultural norms that inform, support and perpetuate barriers, stereotypes and imbalances. We need to expose patriarchism and the gender inequality it inherently creates in order to overcome it for the benefit of society as a whole. And we need to start by empowering those who suffer from it most – women living in situations of extreme poverty – helping them access what is already theirs by right."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": `
    <div class="contentLinkNone abs" style="top: 148px; left: 76px; width: 332px; height: 343px;" onclick="Publish.openArticle(9)"></div>
    <div class="contentLinkNone abs" style="top:548px;left:316px;width:330px;height:256px;" onclick="Publish.openArticle(9)"></div>
    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "searchText": "NEW PROGRAMMES Challenging barriers, empowering women Azad Foundation aims to build gender equality by supporting women to access non-traditional livelihoods and by encouraging men and communities to reject patriarchal concepts, attitudes and behaviours in their daily lives. From 2017 to 2020, we funded Azad’s “Women With Wheels” flagship programme, which trains vulnerable women from deprived backgrounds for employment as professional drivers. We’re now providing core funding to further support Azad’s sustained comprehensive efforts to fight gender stereotypes and barriers in public and private spaces.  Our additional grant will make it possible for Azad Foundation to fine-tune its theory of change and strengthen its operations, building on its outreach efforts in low-income neighbourhoods to support community leader networks, collective advocacy platforms and gender transformative policies.  Partner: IDinsight Duration: 2020-2023  Partner: Azad Foundation Country: India Duration: 2017-20 > 2020-22  IDinsight helps governments and global development leaders generate and use evidence to maximise the impact of their programmes and inform their decision-making.  We are supporting their efforts to evolve their data and evidence tools to bring cutting-edge analytical power to critical challenges for the most vulnerable communities. IDinsight is also working with a number of our grantees, providing light-touch Monitoring and Evaluation (M&E) support and advisory services tailored to each respective organisation’s priorities. This includes establishing M&E frameworks for their programmes or developing data collection strategies for their programme implementation and monitoring.  28 - W O ME N ’ S SO CIA L A N D ECO N O M IC D EVELOPMENT"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": `
    <img class="halfScale 29-text pointer" style="top:542px; left:71px;" onclick="Publish.openArticle(10)" src="/AR2020-21/en/static/_content/29-text-1.png">
    <img class="halfScale 29-text pointer" style="top:775px; left:71px;" onclick="Publish.openArticle(10)" src="/AR2020-21/en/static/_content/29-text-2.png">
    <h1 id="29-no1" class="abs brillcutreg 29-no" style="left: 473px; top: 742px; font-size: 1.6em; font-weight:400; margin:0; color:#218ccd; padding:0; margin:0;"  data-number='{"to": 680}'></h1>
    <div class="contentLinkNone abs" style="top:220px;left:64px;width:270px;height:275px;" onclick="Publish.openArticle(10)"></div>
    `,
    "script": `
      function onPageEnter() {
        pg29Anim = new TimelineMax();
        pg29Anim.staggerFromTo(cOf("29-text"), 0.6, {opacity:0,y:-60}, {opacity:1,y:0, ease: Power2.easeOut}, 0.3, 1)
        .fromTo(cOf("29-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("29-no")[0]);}}, 1.6)

      }
    
      function onPageLeave() {
      pg29Anim.stop();
      }
    `,
    "searchText": "RESULTS A ND FOLLOW-UP Partner: Buildher Country: Kenya Duration: 2019-21 > 2021-23  Empowering women through construction Uneducated and marginalised women from Nairobi’s informal settlements can become skilled carpenters, joiners, painters and plasterers, to enter the construction industry, one of the most gender-segregated and fastest growing sectors in Kenya. That’s the big idea behind Buildher, a Kenyan social enterprise that trains disadvantaged young women in accredited construction skills and crucial life skills to increase their chances of gaining stable employment and greater economic independence, while changing attitudes and promoting gender inclusivity in the sector.  Between 2019 and 2021, Buildher was able to enrol 162 young women living in the Mathare, Korogocho and Huruma slums in its pilot training programme. 111 of these women graduated from the first part of the training, 74 of whom met the requirements for accessing the final modules that lead to the national industrial certification examination. Despite the huge challenges created by the lockdowns to contain the COVID-19 pandemic, 69 graduates  Income increased from  S3 to S8-S12 per day  were able to secure dignified-pay employment  as qualified construction workers.  2021-2023  680 young women  Following the encouraging results of the first grant, we’re continuing to support Buildher to refine and strengthen its training curricula, adapt its placement strategy and prove its model’s ability to meet market needs and demands.  will be enrolled, with 80% expected to transition into long-term employment in construction  WOMEN’S S OC IAL AND EC ONOMIC DEVELOPMENT - 29"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": `
    <img class="halfScale 30-text pointer" style="top:452px; left:89px;" onclick="Publish.openArticle(10)" src="/AR2020-21/en/static/_content/30-text-1.png">
    <img class="halfScale 30-text pointer" style="top:774px; left:89px;" onclick="Publish.openArticle(10)" src="/AR2020-21/en/static/_content/30-text-2.png">
    <div class="contentLinkNone abs" style="top:283px;left:327px;width:335px;height:155px;" onclick="Publish.openArticle(10)"></div>
    `,
    "script": `
      function onPageEnter() {
        pg30Anim = new TimelineMax();
        pg30Anim.staggerFromTo(cOf("30-text"), 0.6, {opacity:0,y:-60}, {opacity:1,y:0, ease: Power2.easeOut}, 0.3, 1)
      }
    
      function onPageLeave() {
      pg30Anim.stop();
      }
    `,
    "searchText": "RESULTS A ND FOLLOW-UP Partner: Women for Women International Countries: Kosovo, Bosnia and Herzegovina Duration: 2  017-20 > 2020-24  Graduating to a brighter future In theory, women in Kosovo have equal rights to employment and family assets. In practice, the persistence of domestic violence, unequal access to education for girls and lack of economic opportunities are all evidence that gender equality is still far from being achieved. As a result, Kosovar women have the lowest employment rates and education levels in all Europe. Between 2017 and 2020, Women for Women International’s local affiliate, Kosova-Women 4 Women, enrolled 536 marginalised women in a yearlong empowerment programme to improve their agency, wellbeing and livelihoods. 80% successfully graduated, learning basic business management and a vocational skill of their choice to increase their ability to earn an income and save. They also gained vital knowledge about reproductive health, hygiene, nutrition, stress management and conflict resolution. To further strengthen the women’s access to sustainable livelihoods, the programme piloted the provision of post-graduation mentoring support, during which start-up capital was made available as an incentive to develop and formalise microbusinesses, mainly in horticulture, beekeeping and garment making. As a result of this tailored support, 63% of graduates became active members of self-formed saving groups, associations and cooperatives over the three years. The women who received advanced business training achieved a 94% increase in monthly earnings (from $76 to $148).  On average the graduates’ incomes increased by 47% and their saving increased by 31%.  2020-2024 We are continuing to support Women for Women’s 12-month social and economic empowerment programme accompanied by tailored post-graduation support in Kosovo and Bosnia and Herzegovina for the next three years. 30 - W O ME N ’ S SO CIA L A N D ECO N O M IC D EVELOPMENT  Reaching 350 women in Kosovo and supporting at least 450 graduates in Kosovo and Bosnia and Herzegovina."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": `
      <h1 id="31-no1" class="abs fancycutreg 31-no" style="left: 419px; top: 594px; font-size: 1.6em; font-weight:400; margin:0; color:#218ccd; padding:0; margin:0;"  data-number='{"to": 135, "append": "%"}'></h1>
      <h1 id="31-no2" class="abs fancycutreg 31-no" style="left: 446px; top: 658px; font-size: 1.6em; font-weight:400; margin:0; color:#218ccd; padding:0; margin:0;"  data-number='{"to": 558, "append": "%"}'></h1>
      <div class="contentLinkNone abs" style="top:233px;left:67px;width:289px;height:573px;" onclick="Publish.openArticle(11)"></div>

    `,
    "script": `
      function onPageEnter() {
        pg31Anim = new TimelineMax();
        pg31Anim.fromTo(cOf("31-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("31-no")[0]);}}, 1)
        .fromTo(cOf("31-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("31-no")[1]);}}, "+=0.2")
      }

      function onPageLeave() {
        pg31Anim.stop();
        resetNumbers("31-no");
        removeContentLinks();
      }
    `,
    "searchText": "RESULTS Partner: Women for Women International Country: Rwanda Duration: 2013-17 > 2017-20  Building hope in Rwanda Working alongside ultra-poor and socially marginalised women in conflict-affected countries, Women for Women International implements a 12-month social and economic empowerment programme - which we have supported in multiple countries since 2013 that helps promote women’s entrepreneurship, financial inclusion and wellbeing, while also facilitating access to support networks. Between 2017 and 2020, 881 ultra-poor women in Rwanda gained access to the knowledge, skills and resources to positively transform their lives, improving their agency, wellbeing and livelihoods. These women improved their knowledge of basic legal and human rights and essential health practices, gained self-confidence, developed their leadership skills, increased their influence in household decision making and learned how to overcome and resolve interpersonal conflicts through negotiation.  488 of the graduates were enrolled in an advanced economic training programme  that provided inputs, micro-capital support and additional technical assistance and business mentoring, which enabled them to build more substantial microentreprises in sectors such as soap and lotion making, brickmaking and the production of leather shoes, bags or handicrafts. As a result of this advanced economic training, the participants increased their incomes by a further 64%.  135%  average increase in monthly earnings (from S20.84 to S46.20)  558%  average and increase in saving (from S20.97 to S138.60)  WOMEN’S S OC IAL AND EC ONOMIC DEVELOPMENT - 31"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": `
      <div class="contentLinkNone abs" style="top:413px;left:77px;width:589px;height:345px;" onclick="Publish.openArticle(12)"></div>
    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "searchText": "ONGOING PROGRAMMES  ASIAN UNIVERSITY FOR WOMEN Bangladesh – 2018-2023 20 young women from disadvantaged backgrounds across Asia are being provided with full scholarships to obtain a university diploma, enabling them to break out in patriarchal societies.  INTERNATIONAL CENTER FOR RESEARCH ON WOMEN  TOSTAN  Rwanda & Tanzania – 2019-2024  Gambia, Guinea-Bissau and Senegal – 2019-2023  A field trial is being conducted to put male engagement strategies to the test, incorporating them in traditional women empowerment programmes run by Women for Women International and Hand in Hand International, involving 900 women and 470 men.  Thousands of communities are learning about human rights, health, sanitation, conflict resolution, economic empowerment and parenting. That knowledge will help them end harmful practices and ensure positive and lasting social transformation.  32 - W O ME N ’ S SO CIA L A N D ECO N O M IC D EVELOPMENT"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": `
    <div class="contentLinkNone abs" style="top:153px;left:77px;width:419px;height:605px;" onclick="Publish.openArticle(12)"></div>
    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "searchText": "MOTHERS2MOTHERS Uganda – 2020-2023 Mentor Mothers are HIV-positive community health workers who deliver life-saving healthcare services to families in health centres and door-to-door. mothers2mothers is expanding its Mentor Mothers model in east-central Uganda.  STRONGMINDS Zambia – 2020-2023 StrongMinds is training community workers to become mental health facilitators and lead group talk therapy that will equip 8,000 women to gain insight into, manage and overcome their depression.  THE BOMA PROJECT Kenya – 2019-2021 BOMA’s transformative graduation programme is helping 500,000 ultra-poor women living in the drylands of northern Kenya to lift themselves and their families out of poverty.  MSI REPRODUCTIVE CHOICES Senegal – 2019-2021 MSI’s mobile outreach teams are providing family planning options and follow-up support free of charge to 12,000 girls and women in the remote communities of north-west Senegal.  WOMEN’S S OC IAL AND EC ONOMIC DEVELOPMENT - 33"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": ``,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "searchText": ""
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": `
      <img class="halfScale 35-title pointer" style="top:249px; left:72px;" onclick="Publish.openArticle(13)" src="/AR2020-21/en/static/_content/35-title-1.png">
      <img class="halfScale 35-sub pointer" style="top:340px; left:369px;" onclick="Publish.openArticle(13)" src="/AR2020-21/en/static/_content/35-sub-1.png">
    `,
    "script": `
      function onPageEnter() {
        pg35Anim = new TimelineMax();
        pg35Anim.fromTo(cOf("35-title"), 0.6, {opacity:0,x:-60}, {opacity:1,x:0, ease: Power2.easeOut}, 1)
        pg35Anim.fromTo(cOf("35-sub"), 0.6, {opacity:0,x:-60}, {opacity:1,x:0, ease: Power2.easeOut}, 1.3)
      }

      function onPageLeave() {
      pg35Anim.stop();
      }
    `,
    "searchText": "SUSTAINABLE LIVELIHOODS AND ECOSYSTEMS The economic recession triggered by the COVID-19 pandemic threatens to push between 119 and 124 million people into extreme poverty and food insecurity. Most of them will be women, family farmers, small fishermen, the young and the informally employed, who often lack the human, physical and social capital to secure sustainable livelihoods and tackle unprecedented moments like this head-on. More than ever, we need to support proven models that build people’s resilience and enhance their ability to make a living in ways that are economically, socially and ecologically sustainable."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": `
    <div class="contentLinkNone abs" style="top:605px;left:77px;width:559px;height:239px;" onclick="Publish.openArticle(14)"></div>
    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "searchText": "NEW PROGRAMMES  Partner: World Bicycle Relief Country: Zambia Duration: 2021-2024  Pedal power  83% of Zambia’s rural population lack access to reliable and affordable transport. As a result, distance and transport costs considerably limit access to essential goods, services, education and economic opportunities. World Bicycle Relief provides specially-designed, locally-assembled robust bicycles for people in need so they can be independent and thrive. For the next three years, World Bicycle Relief will be working with communities in the Mumbwa district of Zambia’s Central Province to establish a sustainable bicycle ecosystem, including local assembly and distribution facility teams, field mechanics trained to service bicycles and social enterprise retail shops established to ensure the availability of quality spare parts and repairs.  This programme will enable 3,900 people, mostly women and girls, to meet their mobility needs and thereby decrease school absenteeism, increase health worker visits to patients and support economic development, while benefitting a total of 19,500 people through shared use. 36 - S U S TA I N ABL E L IVEL IHO O D S A N D ECO S YS T EMS"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": `
    <div class="contentLinkNone abs" style="top:99px;left:64px;width:549px;height:306px;" onclick="Publish.openArticle(14)"></div>
    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "searchText": "Partner: IECD Country: Madagascar Duration: 2017-19 > 2020-23  Empowering small businesses, investing in livelihoods  Research suggests that for every S1 invested in small and growing enterprises, S13 of value is generated within the local economy, thus making them a powerful platform for lifting communities out of poverty. Small businesses are Madagascar’s economic backbone. However, many entrepreneurs lack knowledge, skills and capacity, making their businesses precarious. Since 2017, we have been supporting IECD and its partner Madagascar Enterprise Development to offer management training and individual coaching to current and future microentrepreneurs in Antananarivo. Building on the encouraging results of our initial grant, this renewed support aims to empower 700 start-up entrepreneurs and small business owners to fully assess the feasibility of and strengthen their business ventures. The aim is to make the businesses more profitable and sustainable, improving the living conditions of the entrepreneurs, their families and employees and ultimately developing the local economy.  Our first grant enabled 57% of participants to increase their revenue and helped 79% to start saving.  S US TAINABLE LIVELIHOODS AND EC OS YS T EMS - 37"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": `
    <img class="halfScale 38-text pointer" style="top:579px; left:89px;" onclick="Publish.openArticle(15)" src="/AR2020-21/en/static/_content/38-text-1.png">
    <img class="halfScale 38-text pointer" style="top:726px; left:365px;" onclick="Publish.openArticle(15)" src="/AR2020-21/en/static/_content/38-text-2.png">
    <div class="contentLinkNone abs" style="top:219px;left:74px;width:239px;height:326px;" onclick="Publish.openArticle(15)"></div>
    `,
    "script": `
      function onPageEnter() {
        pg38Anim = new TimelineMax();
        pg38Anim.staggerFromTo(cOf("38-text"), 0.6, {opacity:0,y:-60}, {opacity:1,y:0, ease: Power2.easeOut}, 0.3, 1)
      }
    
      function onPageLeave() {
      pg38Anim.stop();
      }
    `,
    "searchText": "RESULTS A ND FOLLOW-UP Partner: Proximity Designs Country: Myanmar Duration: 2018-20 > 2020-24  Smart design for family farmers The impending economic recession and social disruption resulting from the COVID-19 pandemic and military coup threaten to drag millions of Myanmar family farms – the backbone of the country’s economy - further into poverty and food insecurity. Proximity Designs has been serving Myanmar smallholder farmers for the past 16 years, providing them with low-cost durable products and services with the aim of helping increase their production and income for food, healthcare, farm re-investment and education.  Between 2018 and 2020, we supported Proximity Designs’ efforts to design, produce and market irrigation technologies adapted to the country’s main farming areas. A new ground sprayer for tree-crops such as mango, durian and papaya, a valve connector to control water flow and a warranty on all pipes and pumps are just some of the innovations successfully launched.  Over 59,300 farm families adopted Proximity Designs’ innovative irrigation products, contributing to an average increase of $290 in their annual incomes.  2020-2024 Proximity Designs aims to lift 800,000 farm families – almost 3.5 million women, men and children – out of poverty over the next four years.  Over the coming years, Proximity Designs aims to create a nationwide platform providing an evolving, integrated menu of innovative products and services to small farmers, including farm technology, advice and finance. These services have the common goal of maximising small farm productivity, crop yields and family incomes.  38 - S U S TA I N ABL E L IVEL IHO O D S A N D ECO S YS T EMS"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": `
    <h1 id="39-no1" class="abs brillcutreg 39-no" style="left: 103px; top: 271px; font-size: 1.6em; font-weight:400; margin:0; color:#218ccd; padding:0; margin:0;"  data-number='{"to": 75700, "comma": true}'></h1>
    <div class="contentLinkNone abs" style="top:149px;left:64px;width:579px;height:336px;" onclick="Publish.openArticle(16)"></div>
    `,
    "script": `
      function onPageEnter() {
        pg39Anim = new TimelineMax();
        pg39Anim.fromTo(cOf("39-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("39-no")[0]);}}, 1)

      }
    
      function onPageLeave() {
      pg39Anim.stop();
      }
    `,
    "searchText": "RESULTS From artisanal mining to cocoa farming The Amazonian region of Madre de Dios in Southern Peru is hard hit by pollution from small-scale gold mining, with over Partner: Terre des Hommes Suisse Country: Peru 50% of the population making a living out of intensive panning. Duration: 2013-16 > 2017-20 Choosing to turn the tide, 72 families have abandoned unhealthy gold prospecting practices to establish a cocoa farming cooperative called Agrobosque. For the past four years, Terre des Hommes Suisse has helped Over tons Agrobosque to strengthen the cooperative’s production of cocoa have been produced capacity and marketing to ensure about 250 people improve over the last four years their livelihoods in the long term. The cooperative has expanded the area it cultivates from 250 to 350 hectares, with 250 hectares now having gained organic certification, thus securing enhanced market opportunities. Moreover, in 2019, Agrobosque gained Fairtrade certification. 80% of Agrobosque’s members have obtained access to micro-credits to improve their farming outputs. In 2020, members’ activities were expanded to include the sale of cocoa products, with 2 tons being sold in that first year alone despite the COVID-19 restrictions. In addition, the creation of vegetable gardens has enabled 80% of the cooperative’s members to diversify their revenues and diets.  75,700  S US TAINABLE LIVELIHOODS AND EC OS YS T EMS - 39"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": `
    <div class="contentLinkNone abs" style="top:94px;left:74px;width:395px;height:276px;" onclick="Publish.openArticle(17)"></div>
    <div class="contentLinkNone abs" style="top:544px;left:74px;width:595px;height:299px;" onclick="Publish.openArticle(17)"></div>
    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "searchText": "BRAC  VILLAGE ENTERPRISE  Uganda – 2019-2022  Uganda – 2020-2023  A disability-inclusive ultra-poor graduation programme is enabling 2,700 people and their families to lift themselves out of poverty.  2,700 extremely poor individuals, mostly women, are gaining the knowledge, skills and confidence required to run sustainable microbusinesses.  ONGOING PROGRAMMES ONE ACRE FUND  ROOT CAPITAL  Rwanda – 2020-2023  Peru – 2019-2022  KHEYTI  One Acre Fund is providing smallholder farmers with seeds, fertilisers, financing, training and market facilitation to help them improve their crop yields. The objective is to reach around 1.5 million farmers.  95 rural cooperatives are being provided with the resources, information and capacity they need to fuel their growth and positively impact the lives of the 30,000 family farmers who supply them.  Kheyti’s innovative greenhouse has demonstrated it can increase smallholder farmers’ yields by 700% while using 90% less water. Kheyti is working to sell it to 10,000 farmers by 2022.  40 - S U S TA I N ABL E L IVEL IHO O D S A N D ECO S YS T EMS  India – 2019-2022"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": `
    <div class="contentLinkNone abs" style="top:249px;left:81px;width:419px;height:452px;" onclick="Publish.openArticle(17)"></div>
    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "searchText": "MYAGRO Senegal – 2019-2022 myAgro’s prepaid scratch cards are enabling 75,000 farmers to pay in small instalments for agricultural inputs and training to increase their harvests.  BLUE VENTURES Madagascar – 2018-2021 Fishing communities are managing their marine resources by using temporary fishing bans to allow invertebrate species to replenish, thus obtaining more abundant catches and increasing their income.  EDUCATION FOR EMPLOYMENT Morocco – 2019-2021 430 Moroccans are being trained to improve their soft, technical and digital skills to secure high-demand jobs.  S US TAINABLE LIVELIHOODS AND EC OS YS T EMS - 41"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": ``,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "searchText": ""
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": `
      <img class="halfScale 43-title pointer" style="top:249px; left:90px;" onclick="Publish.openArticle(18)" src="/AR2020-21/en/static/_content/43-title-1.png">
      <img class="halfScale 43-sub pointer" style="top:340px; left:369px;" onclick="Publish.openArticle(18)" src="/AR2020-21/en/static/_content/43-sub-1.png">
    `,
    "script": `
      function onPageEnter() {
        pg43Anim = new TimelineMax();
        pg43Anim.fromTo(cOf("43-title"), 0.6, {opacity:0,x:-60}, {opacity:1,x:0, ease: Power2.easeOut}, 1)
        pg43Anim.fromTo(cOf("43-sub"), 0.6, {opacity:0,x:-60}, {opacity:1,x:0, ease: Power2.easeOut}, 1.3)
      }

      function onPageLeave() {
      pg43Anim.stop();
      }
    `,
    "searchText": "EMERGENCY RESPONSE AND PREPAREDNESS While the COVID-19 pandemic has captured the world’s attention over the past 12 months, other no less devastating crises have required equal if not greater resources to be mobilised to save lives, reduce casualties and relieve suffering. For many communities, the coronavirus has been a tragedy among others, intensifying existing horrors of poverty and environmental instability. We could hardly forget them."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": `
    <h1 id="44-no1" class="abs brillcutmed 44-no" style="left: 528px; top:335px; font-size: 2.1em; font-weight:400; margin:0; color:#218ccd; padding:0; margin:0;"  data-number='{"to": 10700, "comma": true}'></h1>
    <div class="contentLinkNone abs" style="top:153px;left:77px;width:419px;height:275px;" onclick="Publish.openArticle(19)"></div>
    `,
    "script": `
      function onPageEnter() {
        pg44Anim = new TimelineMax();
        pg44Anim.fromTo(cOf("44-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("44-no")[0]);}}, 1)
      }

      function onPageLeave() {
        pg44Anim.stop();
        resetNumbers("44-no");
        removeContentLinks();
      }
    `,
    "searchText": "NEW PROGRAMMES Partner: Medair Country: Lebanon Duration: 2020-2021  Relief and recovery after the Beirut explosions  On 4 August 2020, horrific explosions rocked the Port of Beirut. Homes collapsed, high rise buildings were reduced to hollow frames and the streets for miles around were strewn with rubble. The blasts resulted in massive human loss, with hundreds of people killed, thousands injured and around 300,000 left homeless. Three major hospitals and more than 100 schools and health dispensaries were severely damaged. We’ve been supporting Medair to ensure that essential supplies and healthcare services reach those who need them most. The relief items included emergency shelter materials and repair windows, doors and walls, as well as hygiene and baby care kits. Building on its shelter expertise, Medair has rehabilitated over 1,000 residential buildings and 50 public facilities.  44 - E ME R GE N CY R ESP O N SE A N D P R EPA R EDNES S  10,700 people received relief items"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": `
    <h1 id="45-no1" class="abs brillcutmed 45-no" style="left: 64px; top:705px; font-size: 2.1em; font-weight:400; margin:0; color:#218ccd; padding:0; margin:0;"  data-number='{"to": 50000, "comma": true}'></h1>
    <div class="contentLinkNone abs" style="top:463px;left:237px;width:419px;height:335px;" onclick="Publish.openArticle(19)"></div>
    `,
    "script": `
      function onPageEnter() {
        pg45Anim = new TimelineMax();
        pg45Anim.fromTo(cOf("45-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("45-no")[0]);}}, 1)
      }

      function onPageLeave() {
        pg45Anim.stop();
        resetNumbers("45-no");
        removeContentLinks();
      }
    `,
    "searchText": "Partner: BRAC Country: Bangladesh Duration: 2020-2021  Over  50,000 families reached  Recovering from unprecedented floods in Bangladesh Between June and August 2020, the most severe and prolonged monsoon-related floods in decades devastated the lives of millions of people in South and East Asia. Bangladesh, which was still recovering from the effects of super-cyclone Amphan and struggling to contain the COVID-19 pandemic, was severely impacted. Around 40% of the country was submerged, hundreds of people were killed, over 1 million households flooded and nearly 130,000 hectares of cropland heavily damaged. We’ve been supporting BRAC to provide emergency humanitarian aid to displaced families in seven severely impacted districts. As the flood waters receded and people slowly returned to their homes, BRAC provided cash assistance to repair damaged houses and purchase safe water supply and adequate sanitation facilities. Agricultural inputs including seeds, fertilizers, tools and equipment as well as livestock have helped support affected farmers recover their livelihoods.  EMERG ENC Y RES PONS E AND PREPAREDNES S - 45"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": `
    <a class="contentLinkNone abs" href="https://www.cartierphilanthropy.org" target="_blank" style="top:810px;left:353px;width:201px;height:22px;"></a>
    `,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "searchText": "Acronyms CBM ICRW IECD IFRC MSF SOIL WSUP WFP  Christian Blind Mission International Center for Research on Women European Institute for Cooperation and Development International Federation of Red Cross and Red Crescent Societies Médecins Sans Frontières / Doctors Without Borders Sustainable Organic Integrated Livelihoods Water and Sanitation for the Urban Poor World Food Programme  Photo credits  2  1 5  8  7  3  4  6 10  11  9  1 2 3 4 5 6 7 8 9 10 11  – © MSF / Davide Arcuri – © Techo – © CBM – © SOIL / Felipe Jacome – © The Baan Dek Foundation – © Living Goods / Phionah Katushabe – © MSF / Agnes Varraine-Leca – © Integrate Health – © CBM – © MSF / Atul Loke – © DonorsChoose  Cover: © Cartier Philanthropy / Andrea Borgarello © 1001fontaines (p. 16) © Azad Foundation (p. 28) © Blue Ventures / Garth Cripps (p. 41) © The BOMA Project (p. 33) © Mehedi Hasan / Dhaka Tribune (p. 45, courtesy of BRAC) © Buildher (p. 29) © Cartier Philanthropy / Andrea Borgarello (p. 21, 23-25, 32, 40) © Cartier Philanthropy / Cyril Le Tourneur (p. 19, 22, 26, 30, 33, 38) © Cartier Philanthropy / Irene Amodei (p. 42) © CorStone (p. 17) © Education for Employment (p. 41) © Hand in Hand International / Georgina Goodwin (p. 32) © Healthy Learners (p. 25, 28) © IECD (p. 18, 25. 37) © Integrate Health (p. 24) © Kheyti (p. 40)  © Living Goods / Georgina Goodwin (p. 23) © The Luminos Fund / Rosie Hallam (p. 24) © Medair / Omar Hiba Hajj (p. 44) © mothers2mothers / Karin Schermbrucker (p. 33) © Muso (p. 24) © Gabriel Diamond (courtesy of myAgro) (p. 41) © One Acre Fund / Hailey Tucker (p. 40) © PIVOT (p. 18) © Root Capital (p. 40) © Saha Global (p. 25) © SOIL / Toni Marcelli (p. 25) © StrongMinds (p. 33) © Terre des Hommes Suisse / Jérômine Derigny (p. 34, 39) © Tostan / (p. 32) © WFP / Simon Pierre Diou (p. 24) © WFP / Roberto Masiero (p. 24) © Women for Women International / Hazel Thomson (p. 31) © World Bicycle Relief (p. 36) © WSUP / Tsilavo Rapiera (p. 14, p. 20)  Address  Site web  Rue André-De-Garrini 3 - CH-1217 Meyrin-Genève  www.cartierphilanthropy.org"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": ``,
    "script": `
      function onPageEnter() {
      }

      function onPageLeave() {
      }
    `,
    "searchText": ""
  }]],
  "script": `
    function idOf(id) {
      return document.getElementById(id)
    }

    function cOf(klass) {
      return document.getElementsByClassName(klass)
    }
    
    function removeContentLinks() {
      var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
      contentLinks.map(function callback(e) { 
        return e.className = 'addContentLink'
      })
    }

    function addContentLinks() {
      var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
      contentLinks.map(function callback(e) {
        return e.className = 'contentLink addContentLink'
      })
    }

    function showOverlay(idx) {
      idOf(idx).className = 'contentOverlay visible'
    }

    function hideOverlay(idx) {
      idOf(idx).className = 'contentOverlay hidden noclick'
    }

    function animateNumber(element){
      if(element.getAttribute("data-number")){
        var args = JSON.parse(element.getAttribute("data-number"));
        var from = 0;
        var to = 100;
        var append = "";
        var preppend = "";
        var decimals = 0;
        var duration = 1;
        var ease = "Linear.easeNone";
        var comma = false;
        var separator = ",";
        var decChar = ".";
        for(obj in args){
          if(obj == "from") from = args[obj];
          if(obj == "to") to = args[obj];
          if(obj == "append") append = args[obj];
          if(obj == "preppend") preppend = args[obj];
          if(obj == "decimals") decimals = args[obj];
          if(obj == "duration") duration = args[obj];
          if(obj == "ease") ease = args[obj];
          if(obj == "comma") comma = args[obj];
          if(obj == "separator") separator = args[obj];
          if(obj == "decChar") decChar = args[obj];
        }
        var obj = {number: from}
        TweenMax.to(obj, duration, {number: to, onUpdate: function(){
          if(comma){
            console.log(obj.number)
            var str = obj.number.toFixed(decimals).toString();
            var predec = str.split(/^d*/)[0];
            console.log("PREDEC", predec, typeof(predec));
            var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
            var comp = newstr.replace(/^,/, '')
            console.log("NEWSTR", newstr, typeof(newstr));
            // console.log({newstr})
            // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : "";
            // if(dp[0]) dp = dp[0].replace(".", decChar);
            var dp = "";
            element.innerHTML = preppend+comp+dp+append;
          }else{
            element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
          }
        }, ease: eval(ease)});
      }else{
        return;
      }
    }

    function resetNumbers(ele){
      var numbers = cOf(ele)
      for(var i=0; i<numbers.length; i++) {
        numbers[i].innerText= ""
      }
    }
  `,
    "mobilePages": null,
  "mobileTemplate": null,
  "articles": [{
    "title": "MESSAGE FROM THE PRESIDENT",
    "pageIndex": 7,
    "subIndex": 0,
    "articleIndex": 0,
    "article": `
      <h2>MESSAGE FROM THE PRESIDENT</h2>  

      <p>
        It really is exceptionally difficult to put the last twelve months into words. The COVID-19 pandemic was unprecedented, exposing sweeping vulnerabilities in countries that are normally well-equipped to cope with emergencies while exacerbating already severe inequalities in the world’s poorest regions. Global by nature, it called for an extraordinary response, where communities – local, national and international – suddenly emerged from the shadows of abstraction to become the visible fabric that binds us together as a whole.
      </p>

      <p>
        As a result, I believe we are all more aware of the value of social connections today, of neighbourliness, of a sense of belonging and of mutual trust. We know from experience that this togetherness makes us stronger in the face of adversity. Communities - diverse, informed, supportive and resilient - are our best defence.
      </p>

      <p>
        Cartier and Cartier Philanthropy have contributed actively to the relief efforts since the very beginning of the crisis, providing access to healthcare, education, food, water and sanitation for those most in need, wherever they live - from Italy to the Philippines, Brazil, Madagascar and, most recently, India. Care, compassion, thoughtfulness and collaboration have guided us through the storm, supporting 18 non-profit organisations in 20 countries across every region of the world.
      </p>

      <p>
        Let these values remain our compass as we recover and find ways to build a more equitable, just and inclusive post-COVID world. The stakes are too high to simply go back to the old normal.
      </p>

      <p>
        <b>Cyrille Vigneron</b><br>
        President of the Board, Cartier Philanthropy<br>
        CEO of Cartier
      </p>
    `,
  },{
    "title": "STRATEGIC ADVISOR’S MESSAGE",
    "pageIndex": 8,
    "subIndex": 0,
    "articleIndex": 1,
    "article": `
      <h2>STRATEGIC ADVISOR’S MESSAGE</h2> 
      <p>
        After months on a non-stop emotional roller-coaster, marked by losses, struggles and grief, but also the inspiration that comes from extraordinary displays of courage and solidarity, I’d like to dedicate these words to honouring our incredible partner organisations, who never failed to step up and fight for the people they serve, among the most vulnerable on earth.
      </p>
      <p>
        Since the very beginning of the COVID-19 pandemic, when the one sure thing was that “the only way out was through”, they reacted, adapted, strategized, repurposed and restructured with decisive resolution, demonstrating flexibility, creativity and pragmatism. Identifying potential risks and vulnerabilities, they ensured that critical front-line needs were addressed and no one was left behind, adopting innovative approaches and safety measures to continue delivering on their missions. Because that was all that counted. Make no mistake, they were blind to the crisis like every one of us. But their tenacity in keeping focused throughout the chaos while maintaining a flexible outlook testifies strongly to their extraordinary passion, bravery, determination and resourcefulness.
      </p>
      <p>
        With the crisis not yet over, calling us to face challenges old and new, I believe these examples of unwavering commitment and boundless endurance will be among the most precious legacies of this difficult period. You will recognise them in the following pages, which I invite you to explore, reading about the life-changing impact they have had and will continue to have on so many.
      </p>
      <p>
        <b>Pascale de la Frégonnière</b><br>
        Strategic Advisor, Cartier Philanthropy<br>
      </p>
    `,
  },{
    "title": "COMBATING COVID-19 WORLDWIDE: A YEAR IN REVIEW",
    "pageIndex": 11,
    "subIndex": 0,
    "articleIndex": 2,
    "article": `
      <h2 style="color:rgb(65,135,205)">COMBATING COVID-19 WORLDWIDE<br>
          A YEAR IN REVIEW</h2>  
      <img src="/AR2020-21/en/static/_article/article-2-1.jpg">
      <p>
        We’ve always been committed to addressing the most pressing challenges faced by the world’s least developed regions, where difficulty meeting basic needs can be severe year-round. Confronted with the worst health and humanitarian crisis the world has ever faced, we felt compelled to contribute to the global relief effort, providing assistance where and when needed (even in wealthy countries) as the emergency unfolded and its consequences became better known.
      </p>
      <p>
        Over the past year, we have supported our partners’ relief operations in 20 countries across the globe, providing access to healthcare, education, food, water and sanitation.
      </p>

      <h3 style="color:rgb(65,135,205)">NORTH AMERICA</h3>
      <p>
        <b>The Visiting Nurse Service of New York</b> has sent 11,000 clinicians and home health aides into patients’ homes, alleviating the pressure on hospitals.
      </p>
      <p>
        <b>Harlem Children’s Zone</b> has provided essential social services for over 10,000 people hit hard by the crisis.
      </p>
      <p>
        <b>DonorsChoose</b> has provided teachers and over 35,600 students with home learning support.
      </p>

      <h3 style="color:rgb(65,135,205)">LATIN AMERICA & THE CARIBBEAN</h3>
      <p>
        <b>Techo</b> has provided the most vulnerable families with food and other necessities, distributing over 4,200 emergency kits in Mexico, Brazil, and Colombia.
      </p>
      <p>
        In Haiti, <b>SOIL</b> has provided critical access to safe sanitation and handwashing stations for hundreds of users per day.
      </p>

      <h3 style="color:rgb(65,135,205)">EUROPE</h3>
      <p>
        <b>Médecins Sans Frontières</b> has delivered medical care to people on the move, the homeless and elderly people living in long-term care facilities in Italy, France, Belgium, Spain and Greece.*
      </p>

      <h3 style="color:rgb(65,135,205)">CHINA AND THE MIDDLE EAST</h3>
      <p>
        Cartier contributed early donations to support the <b>Red Cross</b> in Wuhan, China, and <b>The Fund of the United Arab Emirates Homeland of Humanity</b>.**
      </p>

      <h3 style="color:rgb(65,135,205)">ASIA</h3>
      <p>
        In Thailand, <b>Baan Dek Foundation</b> has provided hygiene products, food rations and housing support for families living in Bangkok and Chiang Mai construction camps.
      </p>
      <p>
        In Indonesia, <b>CBM</b> has ensured information on COVID-19 is accessible for people with disabilities, while also providing medicines and cash to 800 households.
      </p>
      <p>
        In the Philippines, the <b>Philippine Disaster Resilience Foundation</b> has provided personal protective equipment and accommodation for 6,500 healthcare workers in 68 hospitals and community centres in Metro Manila, Cebu City and Lanao Del Sur.
      </p>
      <p>
        In India, <b>Médecins Sans Frontières</b> has provided medical assistance to moderate and critical COVID-19 patients while ensuring continuity of care for people suffering from tuberculosis. <b>Educate Girls</b> has provided assistance to 115,000 rural vulnerable households by purchasing and distributing grocery and hygiene kits.***
      </p>

      <h3 style="color:rgb(65,135,205)">AFRICA</h3>
      <p>
        <b>Integrate Health</b> in Togo, <b>PIVOT</b> in Madagascar, <b>Living Goods</b> in Kenya and Saha Global in Ghana have worked to limit the spread of the virus, while ensuring essential health services and water access are maintained.
      </p>
      <p>
        <b>The COVID-19 Action Fund for Africa</b> (CAF-Africa), a collaborative initiative of more than 30 member organisations, is supplying personal protective equipment for 1 million community health workers across the continent.
      </p>
      <br>
      <p style="font-size: 0.8em;">* Donation made in 2019-2020 fiscal year - ** Donation made directly by Cartier - *** Donation made in 2021-2022 fiscal year</p>
    `,
  },{
    "title": "ACCESS TO BASIC SERVICES",
    "pageIndex": 13,
    "subIndex": 0,
    "articleIndex": 3,
    "article": `
      <h2 style="color:rgb(44,50,121)">ACCESS TO BASIC SERVICES</h2>
      <img src="/AR2020-21/en/static/_article/article-3-1.jpg">
      <p>
        The coronavirus crisis has revealed that we all stand to gain from a foundation of universal basic services that not only help ensure society flourishes but also protect us, now and in the future. Quality healthcare, clean drinking water, functioning schools and nutritious food are not desirables, but necessities. If anyone is unable to access them, it’s not just bad news for them. We all lose.
      </p>
    `,
  },{
    "title": "ACCESS TO BASIC SERVICES: NEW PROGRAMMES",
    "pageIndex": 13,
    "subIndex": 0,
    "articleIndex": 4,
    "article": `
      <h2 style="color:rgb(44,50,121)">ACCESS TO BASIC SERVICES: NEW PROGRAMMES</h2> 

      <h3 style="color:rgb(44,50,121)">Small enterprises for clean water</h3>
      <img src="/AR2020-21/en/static/_article/article-4-1.jpg">
      <i>Partner: 1001fontaines | Country: Cambodia | Duration: 2020-2022</i>
      <p>
        In Cambodia, one in three people living in rural communities uses water from unsafe sources. 1001fontaines has been pioneering a social business model that harnesses local entrepreneurship and low-cost technology. Their approach consists in setting up small solar water purification plants, called water kiosks, and training local entrepreneurs to produce safe drinking water, sell it to villagers at an affordable price and distribute it to schools free of charge. This solution has proven its cost-effectiveness, <b style="color:rgb(61,135,205)">sustainability (82% of the water kiosks set up since 2005 are still up and running)</b> and strong positive impact on people’s health.
      </p>
      <p><b>
        We’re supporting 1001fontaines to set up 80 new water kiosks over the next two years and thus grow its operating network to 300 water kiosks serving 900,000 people by 2022.
      </b></p>
      
      <h3 style="color:rgb(44,50,121)">Resilience training changes lives</h3>
      <img src="/AR2020-21/en/static/_article/article-4-2.jpg">
      <i>Partner: CorStone | Country: Rwanda | Duration: 2021-2022</i>
      <p>
        Young people facing challenges benefit significantly from assets such as self-confidence, self-efficacy, optimism, persistence, assertive communication and problem-solving skills, which greatly help overcome obstacles. They are not innate talents, however, but skills that can be taught. Youth First Rwanda is a programme designed to improve the mental and physical well-being and education-related outcomes <b style="color:rgb(61,135,205)">of lower secondary school students (Resilience sessions increase youth confidence to complete their education, delay marriage and childbirth, and achieve career and other life goals.)</b>. It is currently being implemented in a small number of pilot schools in Kigali.
      </p>
      <p><b>
        We’re supporting CorStone to train 350 teachers to facilitate resilience sessions and progressively build tangible resilience skills in 7,500 young students.
      </b></p>
      
      <h3 style="color:rgb(44,50,121)">Last mile primary care in Madagascar</h3>
      <img src="/AR2020-21/en/static/_article/article-4-3.jpg">
      <i>Partner: PIVOT | Country: Madagascar | Duration: 2021-2023</i>
      <p>
        PIVOT has been working alongside the Madagascar Ministry of Public Health since 2014 to transform the public health system in the rural district of Ifanadiana into an evidence-based model of universal health coverage that can be sustained, replicated, and scaled nationally. PIVOT delivers high-quality primary care in health centres across the district, ensuring all facilities are staffed and equipped. With over 70% of the population living more than a 5-kilometre walk from the nearest health facility, PIVOT supports community-level health services through a network of professionalised community health workers who proactively bring care to the patient’s door. The organisation also provides comprehensive support for the district’s public hospital.
      </p>
      <p><b>
        We’re supporting PIVOT’s expansion plan to achieve full primary healthcare coverage in the Ifanadiana district.
      </b></p>
      <p style="color:rgb(61,135,205)">
        22 health facilities will be equipped, and 207 community health workers trained. 
      </p>

      <h3 style="color:rgb(44,50,121)">Building a life of learning</h3>
      <img src="/AR2020-21/en/static/_article/article-4-4.jpg">
      <i>Partner: PIVOT | Country: Madagascar | Duration: 2017-19 > 2020-23</i>
      <p>
        Education levels in Madagascar are among the lowest in the world, with 26% of children under 15 being illiterate. IECD and the Malagasy non-profit organisation PROMES are working to reduce the school drop-out rates of youths in the rural communities of Fianarantsoa region. Their academic support centres offer individual guidance to students, enabling them to enhance their learning and build their personal development.
      </p>
      <p><b>
        After a successful three-year first grant, we’re now co-funding five centres in the Fianarantsoa region which will provide guidance for a total of 430 pupils over three years.
      </b></p>
      <p style="color:rgb(61,135,205)">
        80% of students passed their secondary school exams (BECP) compared with a national average of 53%
      </p>
    `,
  },{
    "title": "ACCESS TO BASIC SERVICES: RESULTS AND FOLLOW-UP",
    "pageIndex": 18,
    "subIndex": 0,
    "articleIndex": 5,
    "article": `
      <h2 style="color:rgb(44,50,121)">ACCESS TO BASIC SERVICES: RESULTS AND FOLLOW-UP</h2>  
      
      <h3 style="color:rgb(44,50,121)">Supporting Indian girls into classrooms</h3>
      <img src="/AR2020-21/en/static/_article/article-5-1.jpg">
      <i>Partner: Educate Girls | Country: India | Duration:  2014-17 > 2017-20 > 2020-24</i>
      <p>
        Educate Girls’ comprehensive model to help reduce the education gender gap in India has snowballed over the past 14 years, proving that it can increase girls’ enrolment and attendance in schools, promote girl-friendly education infrastructures and improve learning outcomes for children. 
      <br>
        Targeting villages with higher concentrations of out-of-school girls – identified using predictive machine learning techniques – Educate Girls builds awareness of the opportunities that come from girls’ education and the roles that parents and communities can and should play in the improvement of school infrastructures and governance.
      </p>
      <p>
        We’ve been supporting Educate Girls in Rajasthan state since 2014 while it fine-tuned and replicated its model to ensure no girl is left behind. A first grant successfully <b style="color:rgb(61,135,205)">enrolled over 37,500 girls</b> in Rajsamand district, <b style="color:rgb(61,135,205)">achieving a retention rate of 93.5%</b>.
      </p>
      <p>
        From 2017 to 2020, our support enabled the <b style="color:rgb(61,135,205)">enrollment of a further 16,800 girls</b> in the same district, achieving an outstanding <b style="color:rgb(61,135,205)">97% retention rate</b>.
      </p>
      <p>
        <b style="color:rgb(61,135,205)">Over 8,000 girls have been empowered</b> with essential life skills to boost their confidence and build their communication, leadership, public-speaking, health, sanitation and problem-solving skills.
      </p>
      <p>
        Nearly <b style="color:rgb(61,135,205)">1,850 School Management Committees</b> of parents, teachers and village leaders responsible for school governance and administration have been formed, directly involving <b style="color:rgb(61,135,205)">over 15,100 members</b>.
      </p>
      <h4 class="article-mini-header">2020-2024</h4>
      <p>
        We’re now providing core funding to enable Educate Girls to scale up its operations and enroll up to <b style="color:rgb(61,135,205)">1.5 million out-of-school girls</b> across <b style="color:rgb(61,135,205)">35,000 villages</b> by 2024 in India’s four most populous states: Rajasthan, Madhya Pradesh, Uttar Pradesh and Bihar.
      </p>
      
      <h3 style="color:rgb(44,50,121)">Bringing water to the urban poor</h3>
      <img src="/AR2020-21/en/static/_article/article-5-2.jpg">
      <i>Partner: Water & sanitation for the Urban Poor (WSUP) | Country: Madagascar | Duration: 2017-20 > 2020-23</i>
      <p>
        The challenges of access to safe sanitation are growing as the world continues to urbanise. This is particularly true in Madagascar, where the number of people living in urban areas is rising at twice the rate as the rest of the country, putting existing sanitation services under increasing pressure. WSUP works with the national water company, local government bodies and communities in Antananarivo to design and build or rehabilitate dedicated services in a manner that ensures their financial viability. WSUP’s approach goes beyond “taps and toilets”, aiming to achieve profound social and functional transformations in water and sanitation systems and policies.
      </p>
      <p>
        The results achieved have been remarkable:
      </p>
      <p>
        The technical assistance and training provided to the national water utility company enabled it to reduce leakage and metering inaccuracies while substantially increasing water supply capacity, providing over <b style="color:rgb(61,135,205)">52,200 people</b> with clean drinking water.
        </p>
        <p>
          <b style="color:rgb(61,135,205)">18 water kiosks</b> and <b style="color:rgb(61,135,205)">3 laundry blocks</b> connected to the city water supply have been established, serving nearly <b style="color:rgb(61,135,205)">7,000 people</b>.
        </p>
        <p>
          <b style="color:rgb(61,135,205)">13 water and sanitation facilities</b> have been built or rehabilitated in <b style="color:rgb(61,135,205)">31 schools</b>, serving <b style="color:rgb(61,135,205)">over 4,700 school children</b> and <b style="color:rgb(61,135,205)">160 teachers</b>.
        </p>
        <p>
          <b style="color:rgb(61,135,205)">6,665 people</b> gained improved access to household sanitation.
        </p>
        <h4 class="article-mini-header">2020-2023</h4>
        <p>
          For the next three years, we’ll be supporting WSUP’s efforts to develop its activities in Antananarivo, Mahajanga, Toliara and their peri-urban areas following a city-wide inclusive sanitation model to achieve universal sanitation coverage for a <b style="color:rgb(61,135,205)">further 100,000 people</b>.
        </p>
      <p>
      
      <h3 style="color:rgb(44,50,121)">Fighting malnutrition with biofortified maize</h3>
      <img src="/AR2020-21/en/static/_article/article-5-3.jpg">
      <i>Partner: Semilla Nueva | Country: Guatemala | Duration: 2016-18 > 2019-21 > 2021-24</i>
      <p>
        In Guatemala, corn tortillas are the ever-present staple of every meal despite being very poor in nutrients. This, combined with lack of dietary diversity, is responsible for chronic malnutrition in around half of Guatemalan children under five.
      <br>
        Semilla Nueva produces and sells biofortified corn seeds conventionally bred to contain higher levels of quality proteins and zinc with the aim of improving the nutrition of millions of Guatemalans.
      </p>
      <p>
        We have been supporting Semilla Nueva to overcome the biggest bottlenecks in developing and expanding the use of biofortified crops in Guatemala since 2016.
      </p>
      <p>
        Between 2019 and 2021, they were able to extend the consumption of biofortified crops, selling nearly 5,200 sacks of seed and <b style="color:rgb(61,135,205)">reaching over 15,300 farming families</b>. These families produced over <b style="color:rgb(61,135,205)">25,000 metric tonnes of more nutritious maize (Enough to feed nearly 300,000 people for a full year)</b>.
      </p>
      <h4 class="article-mini-header">2021-2024</h4>
      <p>
        The organisation aims to show that a government policy incentivising private seed companies to sell biofortified seeds can be one of the most cost-effective solutions for improving nutrition in the country.
        <br>
        Semilla Nueva plans to scale the adoption of biofortified maize by targeting farmers, seed companies and government, while developing competitive new and improved varieties of biofortified seeds with the objective of changing over <b style="color:rgb(61,135,205)">800,000 people’s diets.</b></p>
      <p>
    `,
  },{
    "title": "ACCESS TO BASIC SERVICES: RESULTS",
    "pageIndex": 21,
    "subIndex": 0,
    "articleIndex": 6,
    "article": `
      <h2 style="color:rgb(44,50,121)">ACCESS TO BASIC SERVICES: RESULTS</h2> 
      
      <h3 style="color:rgb(44,50,121)">Reaching where the water doesn’t</h3>
      <img src="/AR2020-21/en/static/_article/article-6-1.jpg">
      <i>Partner: IFRC | Country: Myanmar, Cambodia | Duration: 2015-2020</i>
      <p>
        The main sources of water across much of rural Cambodia and Myanmar are still ponds, hand-dug wells and rainwater harvesting systems. Latrines are uncommon and knowledge of basic hygiene and sanitation practices is scant. Between 2015 and 2020, we supported IFRC and the Myanmar and Cambodian Red Cross to provide clean drinking water and affordable sanitation facilities in rural provinces at high risk of severe water stress.
      </p>
      <p>
        <b>In Cambodia</b><br>
        <b style="color:rgb(61,135,205)">26,505 people and 11 schools</b> gained access to clean drinking water sources and nearly <b style="color:rgb(61,135,205)">20,300 people and 8 schools</b> acquired access to improved sanitation facilities.
      </p>
      <p>
        <b>In Myanmar</b><br>
        <b style="color:rgb(61,135,205)">13,126 people</b> gained access to clean drinking water sources and nearly <b style="color:rgb(61,135,205)">11,400 people</b> acquired access to improved sanitation facilities. All the communities became <b style="color:rgb(61,135,205)">“Open Defecation Free”</b>, which means every household now uses a functional latrine. 
      </p>

      <h3 style="color:rgb(44,50,121)">Delivering health door-to-door</h3>
      <img src="/AR2020-21/en/static/_article/article-6-2.jpg">
      <i>Partner: Living Goods | Country: Kenya | Duration: 2018-2021</i>
      <p>
        Community Health Workers (CHWs) provide the first line of medical care across most of rural Kenya. They go door-to-door to deliver health education, diagnoses and treatments, sell life-saving medicines and make referrals to formal health centres as needed, focusing on pregnant women, mothers and children under five. Living Goods supports networks of government CHWs to ensure they are digitally enabled, properly equipped, effectively supervised and fairly compensated. Over the past two years, we supported Living Goods’ efforts to replicate its model in western Kenya. In that time, the number of CHWs grew by <b style="color:rgb(61,135,205)">115%</b> to almost <b style="color:rgb(61,135,205)">2,700 (This network serves over 1.51 million people)</b>. 
      </p>

      <h3 style="color:rgb(44,50,121)">Zero crop losses for zero hunger</h3>
      <img src="/AR2020-21/en/static/_article/article-6-3.jpg">
      <i>Partner: WFP | Country: Mozambique | Duration:  2017-2020</i>
      <p>
        In Mozambique, over 30% of crops are regularly lost in the weeks following harvest due to traditional household storage and poor crop handling. WFP reached out to <b style="color:rgb(61,135,205)">20,860 smallholder farmers</b> – half of them women – and extension agents, training them to adopt improved practices and storage technologies to drastically reduce these postharvest losses. Nearly <b style="color:rgb(61,135,205)">50,000 hermetic bags</b> were distributed, enabling the <b style="color:rgb(61,135,205)">losses recorded to be reduced from 50% to 9%. </b>
      </p>
    `,
  },{
    "title": "ACCESS TO BASIC SERVICES: ONGOING PROGRAMMES",
    "pageIndex": 23,
    "subIndex": 0,
    "articleIndex": 7,
    "article": `
    <h2 style="color:rgb(44,50,121)">ACCESS TO BASIC SERVICES: ONGOING PROGRAMMES</h2> 
    
    <h3 class="article-mini-header">WORLD FOOD PROGRAMME</h3>
    <p><i>Burkina Faso – 2014-2021</i></p>
    <p>
      A women-led dairy supply chain is linking small-scale cattle farmers and local producers with 71 school canteens where 12,500 school children are being offered fresh yogurt as a mid-morning snack.
    </p>
    <img src="/AR2020-21/en/static/_article/article-7-1.jpg">
    
    <h3 class="article-mini-header">WORLD FOOD PROGRAMME</h3>
    <p><i>Jordan – 2018-2021 </i></p>
    <p>
      6,000 children are receiving school meals thanks to the Healthy Kitchens initiative which employs and empowers 30 Syrian refugee and vulnerable Jordanian women and men.
    </p>
    <img src="/AR2020-21/en/static/_article/article-7-2.jpg">
    
    <h3 class="article-mini-header">VISIONSPRING</h3>
    <p><i>Bangladesh – 2018-2021 </i></p>
    <p>
      VisionSpring is pooling with BRAC to provide durable, attractive and affordable glasses to 600,000 low-income individuals.
    </p>
    <img src="/AR2020-21/en/static/_article/article-7-3.jpg">
    
    <h3 class="article-mini-header">THE LUMINOS FUND</h3>
    <p><i>Ethiopia – 2018-2021</i></p>
    <p>
      10,000 children living in the remote Afar and Oromia regions are being enrolled in a 10-month accelerated learning programme that will enable them to go back to state school.
    </p>
    <img src="/AR2020-21/en/static/_article/article-7-4.jpg">
    
    <h3 class="article-mini-header">INTEGRATE HEALTH</h3>
    <p><i>Togo – 2019-2022 </i></p>
    <p>
      Integrate Health has created a community-led low-cost model to make high-quality primary healthcare available to 240,000 Togolese by 2021.
    </p>
    <img src="/AR2020-21/en/static/_article/article-7-5.jpg">
    
    <h3 class="article-mini-header">MUSO</h3>
    <p><i>Mali – 2019-2022</i></p>
    <p>
      Muso is working with community health workers and government clinics to improve the health of 450,000 patients directly, and of 18 million through government adoption of its model.
    </p>
    <img src="/AR2020-21/en/static/_article/article-7-6.jpg">
    
    <h3 class="article-mini-header">HEALTHY LEARNERS</h3>
    <p><i>Zambia – 2019-2022</i></p>
    <p>
    School teachers are being trained to
    become front-line health workers
    and improve the health of 285,000
    school children in Lusaka and Copperbelt provinces.
    </p>
    <img src="/AR2020-21/en/static/_article/article-7-7.jpg">
    
    <h3 class="article-mini-header">ROOM TO READ</h3>
    <p><i>Bangladesh, Cambodia – 2019-2022</i></p>
    <p>
      4,350 girls in Bangladesh and Cambodia are enrolled in an innovative Girls’ Education Programme to ensure they complete secondary school and gain the skills to negotiate key life decisions.
    </p>
    <img src="/AR2020-21/en/static/_article/article-7-8.jpg">
    
    <h3 class="article-mini-header">IECD</h3>
    <p><i>Lebanon – 2019-2023</i></p>
    <p>
      IECD’s Janah Centre in Beirut is enabling 535 Syrian and Lebanese children and youths to receive academic support, psychological assistance, extracurricular activities and a nutritious daily snack.
    </p>
    <img src="/AR2020-21/en/static/_article/article-7-9.jpg">
    
    <h3 class="article-mini-header">SAHA GLOBAL</h3>
    <p><i>Ghana – 2019-2022</i></p>
    <p>
      Nearly 1,000 women-led water treatment microbusinesses will be launched by the end of 2022 with the aim of providing clean drinking water to 440,000 people.
    </p>
    <img src="/AR2020-21/en/static/_article/article-7-10.jpg">
    
    <h3 class="article-mini-header">SOIL</h3>
    <p><i>Haiti – 2019-2022</i></p>
    <p>
      Safe and cost-effective urban sanitation services are being provided to 12,000 Haitians, combining container-based in-home toilets with regenerative waste treatment services.
    </p>
    <img src="/AR2020-21/en/static/_article/article-7-11.jpg">
    `,
  },{
    "title": "WOMEN’S SOCIAL AND ECONOMIC DEVELOPMENT",
    "pageIndex": 25,
    "subIndex": 0,
    "articleIndex": 8,
    "article": `
      <h2 style="color:rgb(44,50,121)">WOMEN’S SOCIAL AND ECONOMIC DEVELOPMENT</h2>  
      
      <img src="/AR2020-21/en/static/_article/article-8-1.jpg">
      <p>
        Some concepts are like a pair of glasses that allow otherwise invisible things to be seen with sudden clarity. “Patriarchy” is one of them. It consists mainly in a societal structure of power that operates at the expense of women on multiple levels: the state, the law, the school, the home and the cultural norms that inform, support and perpetuate barriers, stereotypes and imbalances. We need to expose patriarchism and the gender inequality it inherently creates in order to overcome it for the benefit of society as a whole. And we need to start by empowering those who suffer from it most – women living in situations of extreme poverty – helping them access what is already theirs by right.
      </p>
    `,
  },{
    "title": "WOMEN’S SOCIAL AND ECONOMIC DEVELOPMENT: NEW PROGRAMMES",
    "pageIndex": 27,
    "subIndex": 0,
    "articleIndex": 9,
    "article": `
      <h2 style="color:rgb(44,50,121)">WOMEN’S SOCIAL AND ECONOMIC DEVELOPMENT: NEW PROGRAMMES</h2>  
      
      <h3>Challenging barriers, empowering women</h3>
      <img src="/AR2020-21/en/static/_article/article-9-1.jpg">
      <i>Partner: Azad Foundation | Country: India | Duration: 2017-20 > 2020-22</i>
      <p>
        Azad Foundation aims to build gender equality by supporting women to access non-traditional livelihoods and by encouraging men and communities to reject patriarchal concepts, attitudes and behaviours in their daily lives. From 2017 to 2020, we funded Azad’s “Women With Wheels” flagship programme, which trains vulnerable women from deprived backgrounds for employment as professional drivers. <b>We’re now providing core funding to further support Azad’s sustained comprehensive efforts to fight gender stereotypes and barriers in public and private spaces.</b> Our additional grant will make it possible for Azad Foundation to fine-tune its theory of change and strengthen its operations, building on its outreach efforts in low-income neighbourhoods to support community leader networks, collective advocacy platforms and gender transformative policies.
      </p>
      
      <hr style="border-color:rgb(28,82,126);width:60%;margin-top:2rem;margin-bottom:3rem;">
      <img src="/AR2020-21/en/static/_article/article-9-2.jpg">
      <i>Partner: IDinsight| Duration: 2020-2023</i>
      <p><b>
        IDinsight helps governments and global development leaders generate and use evidence to maximise the impact of their programmes and inform their decision-making.
      </b></p>
      <p>
        We are supporting their efforts to evolve their data and evidence tools to bring cutting-edge analytical power to critical challenges for the most vulnerable communities. IDinsight is also working with a number of our grantees, providing light-touch Monitoring and Evaluation (M&E) support and advisory services tailored to each respective organisation’s priorities. This includes establishing M&E frameworks for their programmes or developing data collection strategies for their programme implementation and monitoring.
      </p>
      `,
  },{
    "title": "WOMEN’S SOCIAL AND ECONOMIC DEVELOPMENT: RESULTS AND FOLLOW-UP",
    "pageIndex": 28,
    "subIndex": 0,
    "articleIndex": 10,
    "article": `
      <h2 style="color:rgb(44,50,121)">WOMEN’S SOCIAL AND ECONOMIC DEVELOPMENT:  RESULTS AND FOLLOW-UP</h2>  
      
      <h3 style="color:rgb(44,50,121)">Empowering women through construction </h3>
      <img src="/AR2020-21/en/static/_article/article-10-1.jpg">
      <i>Partner: Buildher | Country: Kenya | Duration: 2019-21 > 2021-23</i>
      <p>
        Uneducated and marginalised women from Nairobi’s informal settlements can become skilled carpenters, joiners, painters and plasterers, to enter the construction industry, one of the most gender-segregated and fastest growing sectors in Kenya. That’s the big idea behind Buildher, a Kenyan social enterprise that trains disadvantaged young women in accredited construction skills and crucial life skills to increase their chances of gaining stable employment and greater economic independence, while changing attitudes and promoting gender inclusivity in the sector. 
      </p>
      <p>
        Between 2019 and 2021, Buildher was able to enrol <b style="color:rgb(61,135,205)">162 young women</b> living in the Mathare, Korogocho and Huruma slums in its pilot training programme. <b style="color:rgb(61,135,205)">111</b> of these women <b style="color:rgb(61,135,205)">graduated</b> from the first part of the training, <b style="color:rgb(61,135,205)">74</b> of whom met the requirements for accessing the final modules that lead to the national industrial certification examination. Despite the huge challenges created by the lockdowns to contain the COVID-19 pandemic, <b style="color:rgb(61,135,205)">69 graduates were able to secure dignified-pay employment (Income increased from $3 to $8-$12 per day </b> as qualified construction workers.
      </p>
      <h4 class="article-mini-header">2021-2023</h4>
      <p>
        Following the encouraging results of the first grant, we’re continuing to support Buildher to refine and strengthen its training curricula, adapt its <b style="color:rgb(61,135,205)">placement strategy (680 young women will be enrolled, with 80% expected to transition into long-term employment in construction)</b> and prove its model’s ability to meet market needs and demands.
      </p>
      
      <h3 style="color:rgb(44,50,121)">Graduating to a brighter future</h3>
      <img src="/AR2020-21/en/static/_article/article-10-2.jpg">
      <i>Partner: Women for Women International | Country:  Kosovo, Bosnia and Herzegovina | Duration: 2017-20 > 2020-24</i>
      <p>
        In theory, women in Kosovo have equal rights to employment and family assets. In practice, the persistence of domestic violence, unequal access to education for girls and lack of economic opportunities are all evidence that gender equality is still far from being achieved. As a result, Kosovar women have the lowest employment rates and education levels in all Europe. 
      </p>
      <p>
        Between 2017 and 2020, Women for Women International’s local affiliate, Kosova-Women 4 Women, enrolled <b style="color:rgb(61,135,205)">536 marginalised women</b> in a yearlong empowerment programme to improve their agency, wellbeing and livelihoods. <b style="color:rgb(61,135,205)">80% successfully graduated</b>, learning basic business management and a vocational skill of their choice to <b style="color:rgb(61,135,205)">increase their ability to earn an income and save (on average the graduates’ incomes increased by 47% and their saving increased by 31%.).</b> They also gained vital knowledge about reproductive health, hygiene, nutrition, stress management and conflict resolution.
      </p>
      <p>
        To further strengthen the women’s access to sustainable livelihoods, the programme piloted the provision of post-graduation mentoring support, during which start-up capital was made available as an incentive to develop and formalise microbusinesses, mainly in horticulture, beekeeping and garment making.
      </p>
      <p>
        As a result of this tailored support, <b style="color:rgb(61,135,205)">63% of graduates</b> became active members of self-formed saving groups, associations and cooperatives over the three years. The women who received advanced business training achieved <b style="color:rgb(61,135,205)">a 94% increase in monthly earnings (from $76 to $148).</b>
      </p>
      <h4 class="article-mini-header">2020-2024</h4>
      <p>
        We are continuing to support Women for Women’s 12-month social and economic empowerment programme accompanied by tailored post-graduation support in Kosovo and Bosnia and Herzegovina for the next three years <b style="color:rgb(61,135,205)">(Reaching 350 women in Kosovo and supporting at least 450 graduates in Kosovo and Bosnia and Herzegovina).</b>
      </p>
    `,
  },{
    "title": "WOMEN’S SOCIAL AND ECONOMIC DEVELOPMENT: RESULTS",
    "pageIndex": 30,
    "subIndex": 0,
    "articleIndex": 11,
    "article": `
      <h2 style="color:rgb(44,50,121)">WOMEN’S SOCIAL AND ECONOMIC DEVELOPMENT:  RESULTS</h2>  
      
      <h3 style="color:rgb(44,50,121)">Building hope in Rwanda</h3>
      <img src="/AR2020-21/en/static/_article/article-11-1.jpg">
      <i>Partner: Women for Women International | Country: Rwanda | Duration: 2013-17 > 2017-20</i>
      <p>
        Working alongside ultra-poor and socially marginalised women in conflict-affected countries, Women for Women International implements a 12-month social and economic empowerment programme - which we have supported in multiple countries since 2013 - that helps promote women’s entrepreneurship, financial inclusion and wellbeing, while also facilitating access to support networks. Between 2017 and 2020, <b style="color:rgb(61,135,205)">881 ultra-poor women</b> in Rwanda gained access to the knowledge, skills and resources to positively transform their lives, <b style="color:rgb(61,135,205)">improving their agency, wellbeing and livelihoods (135% average increase in monthly earnings (from S20.84 to S46.20) and 558% average increase in saving (from S20.97 to S138.60)).</b>
      </p>
      <p>
        These women improved their knowledge of basic legal and human rights and essential health practices, gained self-confidence, developed their leadership skills, increased their influence in household decision making and learned how to overcome and resolve interpersonal conflicts through negotiation. 
      </p>
      <p>
        <b style="color:rgb(61,135,205)">488 of the graduates</b> were enrolled in an <b style="color:rgb(61,135,205)">advanced economic training programme</b> that provided inputs, micro-capital support and additional technical assistance and business mentoring, which enabled them to build more substantial microentreprises in sectors such as soap and lotion making, brickmaking and the production of leather shoes, bags or handicrafts. As a result of this advanced economic training, the participants <b style="color:rgb(61,135,205)">increased their incomes by a further 64%.</b>
      </p>
    `,
  },{
    "title": "WOMEN’S SOCIAL AND ECONOMIC DEVELOPMENT: ONGOING PROGRAMMES",
    "pageIndex": 31,
    "subIndex": 0,
    "articleIndex": 12,
    "article": `
      <h2 style="color:rgb(44,50,121)">WOMEN’S SOCIAL AND ECONOMIC DEVELOPMENT: ONGOING PROGRAMMES</h2>  
      
      <h3 class="article-mini-header">ASIAN UNIVERSITY FOR WOMEN</h3>
      <p><i>Bangladesh – 2018-2023</i></p>
      <p>
        20 young women from disadvantaged backgrounds across Asia are being provided with full scholarships to obtain a university diploma, enabling them to break out in patriarchal societies.
      </p>
      <img src="/AR2020-21/en/static/_article/article-12-1.jpg">
      
      <h3 class="article-mini-header">INTERNATIONAL CENTER FOR RESEARCH ON WOMEN</h3>
      <p><i>Rwanda & Tanzania – 2019-2024</i></p>
      <p>
        A field trial is being conducted to put male engagement strategies to the test, incorporating them in traditional women empowerment programmes run by Women for Women International and Hand in Hand International, involving 900 women and 470 men.
      </p>
      <img src="/AR2020-21/en/static/_article/article-12-2.jpg">
      
      <h3 class="article-mini-header">TOSTAN</h3>
      <p><i>Gambia, Guinea-Bissau and Senegal – 2019-2023</i></p>
      <p>
        Thousands of communities are learning about human rights, health, sanitation, conflict resolution, economic empowerment and parenting. That knowledge will help them end harmful practices and ensure positive and lasting social transformation.
      </p>
      <img src="/AR2020-21/en/static/_article/article-12-3.jpg">
      
      <h3 class="article-mini-header">MOTHERS2MOTHERS</h3>
      <p><i>Uganda – 2020-2023</i></p>
      <p>
        Mentor Mothers are HIV-positive community health workers who deliver life-saving healthcare services to families in health centres and door-to-door. mothers2mothers is expanding its Mentor Mothers model in east-central Uganda.
      </p>
      <img src="/AR2020-21/en/static/_article/article-12-4.jpg">
      
      <h3 class="article-mini-header">STRONGMINDS</h3>
      <p><i>Zambia – 2020-2023</i></p>
      <p>
        StrongMinds is training community workers to become mental health facilitators and lead group talk therapy that will equip 8,000 women to gain insight into, manage and overcome their depression.
      </p>
      <img src="/AR2020-21/en/static/_article/article-12-5.jpg">
      
      <h3 class="article-mini-header">THE BOMA PROJECT</h3>
      <p><i>Kenya – 2019-2021</i></p>
      <p>
        BOMA’s transformative graduation programme is helping 500,000 ultra-poor women living in the drylands of northern Kenya to lift themselves and their families out of poverty.
      </p>
      <img src="/AR2020-21/en/static/_article/article-12-6.jpg">
      
      <h3 class="article-mini-header">MSI REPRODUCTIVE CHOICES</h3>
      <p><i>Senegal – 2019-2021</i></p>
      <p>
        MSI’s mobile outreach teams are providing family planning options and follow-up support free of charge to 12,000 girls and women in the remote communities of north-west Senegal.
      </p>
      <img src="/AR2020-21/en/static/_article/article-12-7.jpg">
    `,
  },{
    "title": "SUSTAINABLE LIVELIHOODS AND ECOSYSTEMS",
    "pageIndex": 34,
    "subIndex": 0,
    "articleIndex": 13,
    "article": `
      <h2 style="color:rgb(44,50,121)">SUSTAINABLE LIVELIHOODS AND ECOSYSTEMS</h2>  
      
      <img src="/AR2020-21/en/static/_article/article-13-1.jpg">
      <p>
        The economic recession triggered by the COVID-19 pandemic threatens to push between 119 and 124 million people into extreme poverty and food insecurity. Most of them will be women, family farmers, small fishermen, the young and the informally employed, who often lack the human, physical and social capital to secure sustainable livelihoods and tackle unprecedented moments like this head-on.
      </p>
      <p>
        More than ever, we need to support proven models that build people’s resilience and enhance their ability to make a living in ways that are economically, socially and ecologically sustainable. 
      </p>
      `,
  },{
    "title": "SUSTAINABLE LIVELIHOODS AND ECOSYSTEMS: NEW PROGRAMMES",
    "pageIndex": 35,
    "subIndex": 0,
    "articleIndex": 14,
    "article": `
      <h2 style="color:rgb(44,50,121)">SUSTAINABLE LIVELIHOODS AND ECOSYSTEMS: NEW PROGRAMMES</h2>  
      
      <h3>Pedal power</h3>
      <img src="/AR2020-21/en/static/_article/article-14-1.jpg">
      <i>Partner: World Bicycle Relief | Country: Zambia | Duration: 2021-2024</i>
      <p>
        83% of Zambia’s rural population lack access to reliable and affordable transport. As a result, distance and transport costs considerably limit access to essential goods, services, education and economic opportunities. World Bicycle Relief provides specially-designed, locally-assembled robust bicycles for people in need so they can be independent and thrive. For the next three years, World Bicycle Relief will be working with communities in the Mumbwa district of Zambia’s Central Province to establish a sustainable bicycle ecosystem, including local assembly and distribution facility teams, field mechanics trained to service bicycles and social enterprise retail shops established to ensure the availability of quality spare parts and repairs
      </p>
      <p><b>
        This programme will enable 3,900 people, mostly women and girls, to meet their mobility needs and thereby decrease school absenteeism, increase health worker visits to patients and support economic development, while benefitting a total of 19,500 people through shared use.
      </b></p>
      
      <h3>Empowering small businesses, investing in livelihoods</h3>
      <img src="/AR2020-21/en/static/_article/article-14-2.jpg">
      <i>Partner: IECD | Country: Madagascar | Duration:  2017-19 > 2020-23</i>
      <p>
        Research suggests that for every S1 invested in small and growing enterprises, S13 of value is generated within the local economy, thus making them a powerful platform for lifting communities out of poverty. Small businesses are Madagascar’s economic backbone. However, many entrepreneurs lack knowledge, skills and capacity, making their businesses precarious. Since 2017, we have been supporting IECD and its partner Madagascar Enterprise Development to offer management training and individual coaching to current and future microentrepreneurs in Antananarivo. 
      </p>
      <p><b>
        Building on the encouraging results of our initial grant <b style="color:rgb(61,135,205)">(Our first grant enabled 57% of participants to increase their revenue and helped 79% to start saving)</b>, this renewed support aims to empower 700 start-up entrepreneurs and small business owners to fully assess the feasibility of and strengthen their business ventures. The aim is to make the businesses more profitable and sustainable, improving the living conditions of the entrepreneurs, their families and employees and ultimately developing the local economy. 
      </b></p>
    `,
  },{
    "title": "SUSTAINABLE LIVELIHOODS AND ECOSYSTEMS: RESULTS AND FOLLOW-UP",
    "pageIndex": 37,
    "subIndex": 0,
    "articleIndex": 15,
    "article": `
      <h2 style="color:rgb(44,50,121)">SUSTAINABLE LIVELIHOODS AND ECOSYSTEMS: RESULTS AND FOLLOW-UP</h2>  
            
      <h3 style="color:rgb(44,50,121)">Smart design for family farmers</h3>
      <img src="/AR2020-21/en/static/_article/article-15-1.jpg">
      <i>Partner: Proximity Designs | Country: Myanmar | Duration: 2018-20 > 2020-24</i>
      <p>
        The impending economic recession and social disruption resulting from the COVID-19 pandemic and military coup threaten to drag millions of Myanmar family farms – the backbone of the country’s economy - further into poverty and food insecurity.
      </p>
      <p>
        Proximity Designs has been serving Myanmar smallholder farmers for the past 16 years, providing them with low-cost durable products and services with the aim of helping increase their production and income for food, healthcare, farm re-investment and education.
      </p>
      <p>
        Between 2018 and 2020, we supported Proximity Designs’ efforts to design, produce and market irrigation technologies adapted to the country’s main farming areas. A new ground sprayer for tree-crops such as mango, durian and papaya, a valve connector to control water flow and a warranty on all pipes and pumps are just some of the innovations successfully launched.
      </p>
      <p>
        <b style="color:rgb(61,135,205)">Over 59,300 farm families</b> adopted Proximity Designs’ innovative irrigation products, contributing to an <b style="color:rgb(61,135,205)">average increase of $290 in their annual incomes</b>.
      </p>
      <h4 class="article-mini-header">2020-2024</h4>
      <p>
        Over the coming years, Proximity Designs aims to create a nationwide platform providing an evolving, integrated menu of innovative products and services to small farmers, including farm technology, advice and finance. These services have the common goal of maximising small farm productivity, crop yields and family incomes <b style="color:rgb(61,135,205)">(Proximity Designs aims to lift 800,000 farm families – almost 3.5 million women, men and children – out of poverty over the next four years)</b>. 
      </p>
    `,
  },{
    "title": "SUSTAINABLE LIVELIHOODS AND ECOSYSTEMS: RESULTS",
    "pageIndex": 38,
    "subIndex": 0,
    "articleIndex": 16,
    "article": `
    <h2 style="color:rgb(44,50,121)">WOMEN’S SOCIAL AND ECONOMIC DEVELOPMENT:  RESULTS</h2>  
      
    <h3 style="color:rgb(44,50,121)">From artisanal mining to cocoa farming</h3>
    <img src="/AR2020-21/en/static/_article/article-16-1.jpg">
    <i>Partner:  Terre des Hommes Suisse | Country: Peru | Duration:  2013-16 > 2017-20</i>
    <p>
      The Amazonian region of Madre de Dios in Southern Peru is hard hit by pollution from small-scale gold mining, with over 50% of the population making a living out of intensive panning. Choosing to turn the tide, <b style="color:rgb(61,135,205)">72 families</b> have abandoned unhealthy gold prospecting practices to establish a cocoa farming cooperative called Agrobosque. 
    </p>
    <p>
      For the past four years, Terre des Hommes Suisse has helped Agrobosque to <b style="color:rgb(61,135,205)">strengthen the cooperative’s production capacity (Over 75,700 tons of cocoa have been produced over the last four years)</b> and marketing to ensure about 250 people improve their livelihoods in the long term.
    </p>
    <p>
      The cooperative has expanded the area it cultivates from 250 to <b style="color:rgb(61,135,205)">350 hectares</b>, with 250 hectares now having gained organic certification, thus securing enhanced market opportunities. Moreover, in 2019, <b style="color:rgb(61,135,205)">Agrobosque gained Fairtrade certification</b>.
    </p>
    <p>
      <b style="color:rgb(61,135,205)">80%</b> of Agrobosque’s members have obtained access to micro-credits to improve their farming outputs. In 2020, members’ activities were expanded to include the sale of cocoa products, with <b style="color:rgb(61,135,205)">2 tons</b> being sold in that first year alone despite the COVID-19 restrictions. 
    </p>
    <p>
      In addition, the creation of vegetable gardens has enabled <b style="color:rgb(61,135,205)">80%</b> of the cooperative’s members to diversify their revenues and diets.
    </p>
    `,
  },{
    "title": "SUSTAINABLE LIVELIHOODS AND ECOSYSTEMS: ONGOING PROGRAMS",
    "pageIndex": 39,
    "subIndex": 0,
    "articleIndex": 17,
    "article": `
      <h2 style="color:rgb(44,50,121)">SUSTAINABLE LIVELIHOODS AND ECOSYSTEMS: ONGOING PROGRAMS</h2>  
      
      <h3 class="article-mini-header">BRAC</h3>
      <p><i>Uganda – 2019-2022</i></p>
      <p>
        A disability-inclusive ultra-poor graduation programme is enabling 2,700 people and their families to lift themselves out of poverty. 
      </p>
      <img src="/AR2020-21/en/static/_article/article-17-1.jpg">
      
      <h3 class="article-mini-header">VILLAGE ENTERPRISE</h3>
      <p><i>Uganda – 2020-2023 </i></p>
      <p>
        2,700 extremely poor individuals, mostly women, are gaining the knowledge, skills and confidence required to run sustainable microbusinesses. 
      </p>
      <img src="/AR2020-21/en/static/_article/article-17-2.jpg">
      
      <h3 class="article-mini-header">ONE ACRE FUND </h3>
      <p><i>Rwanda – 2020-2023</i></p>
      <p>
        One Acre Fund is providing smallholder farmers with seeds, fertilisers, financing, training and market facilitation to help them improve their crop yields. The objective is to reach around 1.5 million farmers. 
      </p>
      <img src="/AR2020-21/en/static/_article/article-17-3.jpg">
      
      <h3 class="article-mini-header">ROOT CAPITAL</h3>
      <p><i>Peru – 2019-2022</i></p>
      <p>
        95 rural cooperatives are being provided with the resources, information and capacity they need to fuel their growth and positively impact the lives of the 30,000 family farmers who supply them. 
      </p>
      <img src="/AR2020-21/en/static/_article/article-17-4.jpg">
      
      <h3 class="article-mini-header">KHEYTI</h3>
      <p><i>India – 2019-2022</i></p>
      <p>
        Kheyti’s innovative greenhouse has demonstrated it can increase smallholder farmers’ yields by 700% while using 90% less water. Kheyti is working to sell it to 10,000 farmers by 2022. 
      </p>
      <img src="/AR2020-21/en/static/_article/article-17-5.jpg">
      
      <h3 class="article-mini-header">MYAGRO</h3>
      <p><i>Senegal – 2019-2022</i></p>
      <p>
        myAgro’s prepaid scratch cards are enabling 75,000 farmers to pay in small instalments for agricultural inputs and training to increase their harvests. 
      </p>
      <img src="/AR2020-21/en/static/_article/article-17-6.jpg">
      
      <h3 class="article-mini-header">BLUE VENTURES</h3>
      <p><i>Madagascar – 2018-2021</i></p>
      <p>
        Fishing communities are managing their marine resources by using temporary fishing bans to allow invertebrate species to replenish, thus obtaining more abundant catches and increasing their income.
      </p>
      <img src="/AR2020-21/en/static/_article/article-17-7.jpg">
      
      <h3 class="article-mini-header">EDUCATION FOR EMPLOYMENT</h3>
      <p><i>Morocco – 2019-2021</i></p>
      <p>
        430 Moroccans are being trained to improve their soft, technical and digital skills to secure high-demand jobs. 
      </p>
      <img src="/AR2020-21/en/static/_article/article-17-8.jpg">
    `,
  },{
    "title": "EMERGENCY RESPONSE AND PREPAREDNESS",
    "pageIndex": 41,
    "subIndex": 0,
    "articleIndex": 18,
    "article": `
      <h2 style="color:rgb(44,50,121)">EMERGENCY RESPONSE AND PREPAREDNESS</h2>  

      <img src="/AR2020-21/en/static/_article/article-18-1.jpg">
      <p>
        While the COVID-19 pandemic has captured the world’s attention over the past 12 months, other no less devastating crises have required equal if not greater resources to be mobilised to save lives, reduce casualties and relieve suffering. For many communities, the coronavirus has been a tragedy among others, intensifying existing horrors of poverty and environmental instability. We could hardly forget them.
      </p>
    `,
  },{
    "title": "EMERGENCY RESPONSE AND PREPAREDNESS: NEW PROGRAMMES",
    "pageIndex": 43,
    "subIndex": 0,
    "articleIndex": 19,
    "article": `
      <h2 style="color:rgb(44,50,121)">EMERGENCY RESPONSE AND PREPAREDNESS: NEW PROGRAMMES</h2>  

      <h3 class="article-mini-header">Relief and recovery after the Beirut explosions</h3>
      <img src="/AR2020-21/en/static/_article/article-19-1.jpg">
      <i>Partner: Medair | Country: Lebanon | Duration:  2020-2021</i>
      <p>
        On 4 August 2020, horrific explosions rocked the Port of Beirut. Homes collapsed, high rise buildings were reduced to hollow frames and the streets for miles around were strewn with rubble. The blasts resulted in massive human loss, with hundreds of people killed, thousands injured and around 300,000 left homeless. Three major hospitals and more than 100 schools and health dispensaries were severely damaged.
      </p>
      <p>
        We’ve been supporting Medair to ensure that essential supplies and healthcare services reach those <b style="color:rgb(61,135,205)">who need them most (10,700 people received relief items)</b>. The relief items included emergency shelter materials and repair windows, doors and walls, as well as hygiene and baby care kits. Building on its shelter expertise, Medair has <b style="color:rgb(61,135,205)">rehabilitated over 1,000 residential buildings and 50 public facilities</b>.
      </p>

      <h3 class="article-mini-header">Recovering from unprecedented
      floods in Bangladesh</h3>
      <img src="/AR2020-21/en/static/_article/article-19-2.jpg">
      <i>Partner: BRAC | Country: Bangladesh | Duration: 2020-2021</i>
      <p>
        Between June and August 2020, the most severe and prolonged monsoon-related floods in decades devastated the lives of millions of people in South and East Asia. Bangladesh, which was still recovering from the effects of super-cyclone Amphan and struggling to contain the COVID-19 pandemic, was severely impacted. Around 40% of the country was submerged, hundreds of people were killed, over 1 million households flooded and nearly 130,000 hectares of cropland heavily damaged.
      </p>
      <p>
        We’ve been supporting BRAC to provide <b style="color:rgb(61,135,205)">emergency humanitarian aid (Over 50,000 families reached)</b> to displaced families in seven severely impacted districts. As the flood waters receded and people slowly returned to their homes, BRAC provided <b style="color:rgb(61,135,205)">cash assistance</b> to repair damaged houses and purchase safe water supply and adequate sanitation facilities. <b style="color:rgb(61,135,205)">Agricultural inputs</b> including seeds, fertilizers, tools and equipment as well as <b style="color:rgb(61,135,205)">livestock</b> have helped support affected farmers recover their livelihoods.
      </p>
    `,
  }
  ],}


// WEBPACK FOOTER //
// ./src/document.js